<template>
  <div class="c202a-offline">
    <div class="pagemargins">
      <table cellspacing="0" cellpadding="0" border="1" style="border-width: 0px; width: 718px; white-space: normal">
        <tr style="height: 4px">
          <td class="s5cd6f754" style="width: 23px; height: 4px"></td>
          <td class="s5cd6f754" style="width: 94px; height: 4px"></td>
          <td class="s5cd6f754" style="width: 4px; height: 4px"></td>
          <td class="s5cd6f754" style="width: 23px; height: 4px"></td>
          <td style="height: 4px; width: 49px; border: 0px"></td>
          <td style="height: 4px; width: 26px; border: 0px"></td>
          <td style="height: 4px; width: 19px; border: 0px"></td>
          <td style="height: 4px; width: 4px; border: 0px"></td>
          <td style="height: 4px; width: 56px; border: 0px"></td>
          <td style="height: 4px; width: 1px; border: 0px"></td>
          <td style="height: 4px; width: 15px; border: 0px"></td>
          <td style="height: 4px; width: 3px; border: 0px"></td>
          <td style="height: 4px; width: 12px; border: 0px"></td>
          <td style="height: 4px; width: 4px; border: 0px"></td>
          <td style="height: 4px; width: 3px; border: 0px"></td>
          <td style="height: 4px; width: 19px; border: 0px"></td>
          <td style="height: 4px; width: 19px; border: 0px"></td>
          <td style="height: 4px; width: 15px; border: 0px"></td>
          <td style="height: 4px; width: 12px; border: 0px"></td>
          <td style="height: 4px; width: 7px; border: 0px"></td>
          <td style="height: 4px; width: 34px; border: 0px"></td>
          <td style="height: 4px; width: 38px; border: 0px"></td>
          <td style="height: 4px; width: 23px; border: 0px"></td>
          <td style="height: 4px; width: 3px; border: 0px"></td>
          <td style="height: 4px; width: 8px; border: 0px"></td>
          <td style="height: 4px; width: 4px; border: 0px"></td>
          <td style="height: 4px; width: 41px; border: 0px"></td>
          <td style="height: 4px; width: 19px; border: 0px"></td>
          <td style="height: 4px; width: 8px; border: 0px"></td>
          <td style="height: 4px; width: 15px; border: 0px"></td>
          <td style="height: 4px; width: 98px; border: 0px"></td>
          <td style="height: 4px; width: 1px; border: 0px"></td>
          <td style="height: 4px; width: 14px; border: 0px"></td>
          <td style="height: 4px; width: 4px; border: 0px"></td>
        </tr>
        <tr style="height: 41px">
          <td
            class="sDetailTextCenter"
            colspan="4"
            rowspan="2"
            style="height: 63px; width: 143px; max-height: 63px; max-width: 143px"
          >
            Không ghi vào <br />khu vực này
          </td>
          <td class="sd400aa50" style="width: 49px; height: 40px"></td>
          <td style="height: 40px; width: 26px; border: 0px"></td>
          <td style="height: 40px; width: 19px; border: 0px"></td>
          <td style="height: 40px; width: 4px; border: 0px"></td>
          <td style="height: 40px; width: 56px; border: 0px"></td>
          <td style="height: 40px; width: 1px; border: 0px"></td>
          <td style="height: 40px; width: 15px; border: 0px"></td>
          <td style="height: 40px; width: 3px; border: 0px"></td>
          <td style="height: 40px; width: 12px; border: 0px"></td>
          <td style="height: 40px; width: 4px; border: 0px"></td>
          <td style="height: 40px; width: 3px; border: 0px"></td>
          <td style="height: 40px; width: 19px; border: 0px"></td>
          <td style="height: 40px; width: 19px; border: 0px"></td>
          <td style="height: 40px; width: 15px; border: 0px"></td>
          <td style="height: 40px; width: 12px; border: 0px"></td>
          <td style="height: 40px; width: 7px; border: 0px"></td>
          <td style="height: 40px; width: 34px; border: 0px"></td>
          <td style="height: 40px; width: 38px; border: 0px"></td>
          <td class="sCT_FormNo" colspan="10" style="height: 41px; width: 220px; max-height: 41px; max-width: 220px">
            Mẫu số 16a1<br />Ký hiệu: C2-02a/NS
          </td>
          <td style="height: 40px; width: 14px; border: 0px"></td>
          <td style="height: 40px; width: 4px; border: 0px"></td>
        </tr>
        <tr style="height: 23px">
          <td class="sd400aa50" style="width: 49px; height: 23px"></td>
          <td style="height: 23px; width: 26px; border: 0px"></td>
          <td style="height: 23px; width: 19px; border: 0px"></td>
          <td style="height: 23px; width: 4px; border: 0px"></td>
          <td style="height: 23px; width: 56px; border: 0px"></td>
          <td style="height: 23px; width: 1px; border: 0px"></td>
          <td style="height: 23px; width: 15px; border: 0px"></td>
          <td style="height: 23px; width: 3px; border: 0px"></td>
          <td style="height: 23px; width: 12px; border: 0px"></td>
          <td style="height: 23px; width: 4px; border: 0px"></td>
          <td style="height: 23px; width: 3px; border: 0px"></td>
          <td style="height: 23px; width: 19px; border: 0px"></td>
          <td style="height: 23px; width: 19px; border: 0px"></td>
          <td style="height: 23px; width: 15px; border: 0px"></td>
          <td style="height: 23px; width: 12px; border: 0px"></td>
          <td style="height: 23px; width: 7px; border: 0px"></td>
          <td style="height: 23px; width: 34px; border: 0px"></td>
          <td style="height: 23px; width: 38px; border: 0px"></td>
          <td class="sDetailText" colspan="8" style="height: 23px; width: 121px; max-height: 23px; max-width: 121px">
            Số: {{ model.ref_no }}
          </td>
          <td class="sDetailText1" style="height: 23px; width: 98px; max-height: 23px; max-width: 98px">
            Năm NS: {{ model.posted_year }}
          </td>
          <td style="height: 23px; width: 1px; border: 0px"></td>
          <td style="height: 23px; width: 14px; border: 0px"></td>
          <td style="height: 23px; width: 4px; border: 0px"></td>
        </tr>
        <tr style="height: 4px">
          <td class="sf672e7c2" style="width: 23px; height: 3px"></td>
          <td class="sf672e7c2" style="width: 94px; height: 3px"></td>
          <td class="sf672e7c2" style="width: 4px; height: 3px"></td>
          <td class="sf672e7c2" style="width: 23px; height: 3px"></td>
          <td style="height: 3px; width: 49px; border: 0px"></td>
          <td style="height: 3px; width: 26px; border: 0px"></td>
          <td style="height: 3px; width: 19px; border: 0px"></td>
          <td style="height: 3px; width: 4px; border: 0px"></td>
          <td style="height: 3px; width: 56px; border: 0px"></td>
          <td style="height: 3px; width: 1px; border: 0px"></td>
          <td style="height: 3px; width: 15px; border: 0px"></td>
          <td style="height: 3px; width: 3px; border: 0px"></td>
          <td style="height: 3px; width: 12px; border: 0px"></td>
          <td style="height: 3px; width: 4px; border: 0px"></td>
          <td style="height: 3px; width: 3px; border: 0px"></td>
          <td style="height: 3px; width: 19px; border: 0px"></td>
          <td style="height: 3px; width: 19px; border: 0px"></td>
          <td style="height: 3px; width: 15px; border: 0px"></td>
          <td style="height: 3px; width: 12px; border: 0px"></td>
          <td style="height: 3px; width: 7px; border: 0px"></td>
          <td style="height: 3px; width: 34px; border: 0px"></td>
          <td style="height: 3px; width: 38px; border: 0px"></td>
          <td style="height: 3px; width: 23px; border: 0px"></td>
          <td style="height: 3px; width: 3px; border: 0px"></td>
          <td style="height: 3px; width: 8px; border: 0px"></td>
          <td style="height: 3px; width: 4px; border: 0px"></td>
          <td style="height: 3px; width: 41px; border: 0px"></td>
          <td style="height: 3px; width: 19px; border: 0px"></td>
          <td style="height: 3px; width: 8px; border: 0px"></td>
          <td style="height: 3px; width: 15px; border: 0px"></td>
          <td style="height: 3px; width: 98px; border: 0px"></td>
          <td style="height: 3px; width: 1px; border: 0px"></td>
          <td style="height: 3px; width: 14px; border: 0px"></td>
          <td style="height: 3px; width: 4px; border: 0px"></td>
        </tr>
        <tr style="height: 29px">
          <td class="sCT_Title" colspan="33" style="height: 29px; width: 714px; max-height: 29px; max-width: 714px">
            GIẤY RÚT DỰ TOÁN NGÂN SÁCH NHÀ NƯỚC
          </td>
          <td style="height: 29px; width: 4px; border: 0px"></td>
        </tr>
        <tr style="height: 4px">
          <td style="height: 4px; width: 23px; border: 0px"></td>
          <td style="height: 4px; width: 94px; border: 0px"></td>
          <td style="height: 4px; width: 4px; border: 0px"></td>
          <td style="height: 4px; width: 23px; border: 0px"></td>
          <td style="height: 4px; width: 49px; border: 0px"></td>
          <td style="height: 4px; width: 26px; border: 0px"></td>
          <td style="height: 4px; width: 19px; border: 0px"></td>
          <td style="height: 4px; width: 4px; border: 0px"></td>
          <td style="height: 4px; width: 56px; border: 0px"></td>
          <td style="height: 4px; width: 1px; border: 0px"></td>
          <td class="s5cd6f754" style="width: 15px; height: 4px"></td>
          <td style="height: 4px; width: 3px; border: 0px"></td>
          <td style="height: 4px; width: 12px; border: 0px"></td>
          <td style="height: 4px; width: 4px; border: 0px"></td>
          <td style="height: 4px; width: 3px; border: 0px"></td>
          <td style="height: 4px; width: 19px; border: 0px"></td>
          <td style="height: 4px; width: 19px; border: 0px"></td>
          <td class="s5cd6f754" style="width: 15px; height: 4px"></td>
          <td style="height: 4px; width: 12px; border: 0px"></td>
          <td style="height: 4px; width: 7px; border: 0px"></td>
          <td style="height: 4px; width: 34px; border: 0px"></td>
          <td style="height: 4px; width: 38px; border: 0px"></td>
          <td style="height: 4px; width: 23px; border: 0px"></td>
          <td class="s5cd6f754" style="width: 3px; height: 4px"></td>
          <td class="s5cd6f754" style="width: 8px; height: 4px"></td>
          <td class="s5cd6f754" style="width: 4px; height: 4px"></td>
          <td style="height: 4px; width: 41px; border: 0px"></td>
          <td style="height: 4px; width: 19px; border: 0px"></td>
          <td style="height: 4px; width: 8px; border: 0px"></td>
          <td style="height: 4px; width: 15px; border: 0px"></td>
          <td style="height: 4px; width: 98px; border: 0px"></td>
          <td style="height: 4px; width: 1px; border: 0px"></td>
          <td style="height: 4px; width: 14px; border: 0px"></td>
          <td style="height: 4px; width: 4px; border: 0px"></td>
        </tr>
        <tr style="height: 15px">
          <td style="height: 14px; width: 23px; border: 0px"></td>
          <td style="height: 14px; width: 94px; border: 0px"></td>
          <td style="height: 14px; width: 4px; border: 0px"></td>
          <td style="height: 14px; width: 23px; border: 0px"></td>
          <td style="height: 14px; width: 49px; border: 0px"></td>
          <td style="height: 14px; width: 26px; border: 0px"></td>
          <td style="height: 14px; width: 19px; border: 0px"></td>
          <td
            class="sDetailText2"
            colspan="2"
            rowspan="2"
            style="height: 19px; width: 60px; max-height: 19px; max-width: 60px"
          >
            Thực chi
          </td>
          <td class="s584be2f9" style="width: 1px; height: 14px"></td>
          <td class="sDetailTextCenter" style="height: 14px; width: 14px">
            {{ model.cash_withdraw_type_id == 6 ? 'x' : '' }}
          </td>
          <td class="sd400aa50" style="width: 3px; height: 14px"></td>
          <td
            class="sDetailText2"
            colspan="5"
            rowspan="2"
            style="height: 19px; width: 57px; max-height: 19px; max-width: 57px"
          >
            Tạm ứng
          </td>
          <td class="sDetailTextCenter" style="height: 14px; width: 14px">
            {{ model.cash_withdraw_type_id == 2 || model.cash_withdraw_type_id == 3 ? 'x' : '' }}
          </td>
          <td class="s9f47607e" style="width: 12px; height: 14px"></td>
          <td class="s6f01f6ff border-left" style="width: 7px; height: 14px"></td>
          <td
            class="sDetailText1"
            colspan="3"
            rowspan="2"
            style="height: 19px; width: 95px; max-height: 19px; max-width: 95px"
          >
            Chuyển khoản
          </td>
          <td class="sCT_Table_DetailText_MLNS" colspan="3" style="width: 14px; height: 14px">
            {{ model.PaymentMethod == 0 ? 'x' : '' }}
          </td>
          <td class="sd400aa50" style="width: 41px; height: 14px"></td>
          <td style="height: 14px; width: 19px; border: 0px"></td>
          <td style="height: 14px; width: 8px; border: 0px"></td>
          <td style="height: 14px; width: 15px; border: 0px"></td>
          <td style="height: 14px; width: 98px; border: 0px"></td>
          <td style="height: 14px; width: 1px; border: 0px"></td>
          <td style="height: 14px; width: 14px; border: 0px"></td>
          <td style="height: 14px; width: 4px; border: 0px"></td>
        </tr>
        <tr style="height: 4px">
          <td style="height: 3px; width: 23px; border: 0px"></td>
          <td style="height: 3px; width: 94px; border: 0px"></td>
          <td style="height: 3px; width: 4px; border: 0px"></td>
          <td style="height: 3px; width: 23px; border: 0px"></td>
          <td style="height: 3px; width: 49px; border: 0px"></td>
          <td style="height: 3px; width: 26px; border: 0px"></td>
          <td style="height: 3px; width: 19px; border: 0px"></td>
          <td style="height: 3px; width: 1px; border: 0px"></td>
          <td class="sf672e7c2" style="width: 15px; height: 3px"></td>
          <td style="height: 3px; width: 3px; border: 0px"></td>
          <td class="sf672e7c2" style="width: 15px; height: 3px"></td>
          <td class="sf7752501" style="width: 12px; height: 3px"></td>
          <td class="s6f01f6ff border-left" style="width: 7px; height: 3px"></td>
          <td class="s9bbd135f" style="width: 3px; height: 3px"></td>
          <td class="s9bbd135f" style="width: 8px; height: 3px"></td>
          <td class="s9bbd135f" style="width: 4px; height: 3px"></td>
          <td style="height: 3px; width: 41px; border: 0px"></td>
          <td style="height: 3px; width: 19px; border: 0px"></td>
          <td style="height: 3px; width: 8px; border: 0px"></td>
          <td style="height: 3px; width: 15px; border: 0px"></td>
          <td style="height: 3px; width: 98px; border: 0px"></td>
          <td style="height: 3px; width: 1px; border: 0px"></td>
          <td style="height: 3px; width: 14px; border: 0px"></td>
          <td style="height: 3px; width: 4px; border: 0px"></td>
        </tr>
        <tr style="height: 15px">
          <td style="height: 14px; width: 23px; border: 0px"></td>
          <td style="height: 14px; width: 94px; border: 0px"></td>
          <td style="height: 14px; width: 4px; border: 0px"></td>
          <td style="height: 14px; width: 23px; border: 0px"></td>
          <td style="height: 14px; width: 49px; border: 0px"></td>
          <td style="height: 14px; width: 26px; border: 0px"></td>
          <td style="height: 14px; width: 19px; border: 0px"></td>
          <td style="height: 14px; width: 4px; border: 0px"></td>
          <td style="height: 14px; width: 56px; border: 0px"></td>
          <td style="height: 14px; width: 1px; border: 0px"></td>
          <td style="height: 14px; width: 15px; border: 0px"></td>
          <td style="height: 14px; width: 3px; border: 0px"></td>
          <td style="height: 14px; width: 12px; border: 0px"></td>
          <td style="height: 14px; width: 4px; border: 0px"></td>
          <td style="height: 14px; width: 3px; border: 0px"></td>
          <td style="height: 14px; width: 19px; border: 0px"></td>
          <td style="height: 14px; width: 19px; border: 0px"></td>
          <td style="height: 14px; width: 15px; border: 0px"></td>
          <td class="sf7752501" style="width: 12px; height: 14px"></td>
          <td class="s6f01f6ff border-left" style="width: 7px; height: 14px"></td>
          <td
            class="sDetailText1"
            colspan="3"
            rowspan="2"
            style="height: 19px; width: 95px; max-height: 19px; max-width: 95px"
          >
            Tiền mặt tại KB
          </td>
          <td class="sCT_Table_DetailText_MLNS" colspan="3" style="width: 14px; height: 14px">
            {{ model.PaymentMethod == 2 ? 'x' : '' }}
          </td>
          <td class="sd400aa50" style="width: 41px; height: 14px"></td>
          <td style="height: 14px; width: 19px; border: 0px"></td>
          <td style="height: 14px; width: 8px; border: 0px"></td>
          <td style="height: 14px; width: 15px; border: 0px"></td>
          <td style="height: 14px; width: 98px; border: 0px"></td>
          <td style="height: 14px; width: 1px; border: 0px"></td>
          <td style="height: 14px; width: 14px; border: 0px"></td>
          <td style="height: 14px; width: 4px; border: 0px"></td>
        </tr>
        <tr style="height: 4px">
          <td style="height: 3px; width: 23px; border: 0px"></td>
          <td style="height: 3px; width: 94px; border: 0px"></td>
          <td style="height: 3px; width: 4px; border: 0px"></td>
          <td style="height: 3px; width: 23px; border: 0px"></td>
          <td style="height: 3px; width: 49px; border: 0px"></td>
          <td style="height: 3px; width: 26px; border: 0px"></td>
          <td style="height: 3px; width: 19px; border: 0px"></td>
          <td style="height: 3px; width: 4px; border: 0px"></td>
          <td style="height: 3px; width: 56px; border: 0px"></td>
          <td style="height: 3px; width: 1px; border: 0px"></td>
          <td style="height: 3px; width: 15px; border: 0px"></td>
          <td style="height: 3px; width: 3px; border: 0px"></td>
          <td style="height: 3px; width: 12px; border: 0px"></td>
          <td style="height: 3px; width: 4px; border: 0px"></td>
          <td style="height: 3px; width: 3px; border: 0px"></td>
          <td style="height: 3px; width: 19px; border: 0px"></td>
          <td style="height: 3px; width: 19px; border: 0px"></td>
          <td style="height: 3px; width: 15px; border: 0px"></td>
          <td class="sf7752501" style="width: 12px; height: 3px"></td>
          <td class="s6f01f6ff border-left" style="width: 7px; height: 3px"></td>
          <td class="s9bbd135f" style="width: 3px; height: 3px"></td>
          <td class="s9bbd135f" style="width: 8px; height: 3px"></td>
          <td class="s9bbd135f" style="width: 4px; height: 3px"></td>
          <td style="height: 3px; width: 41px; border: 0px"></td>
          <td style="height: 3px; width: 19px; border: 0px"></td>
          <td style="height: 3px; width: 8px; border: 0px"></td>
          <td style="height: 3px; width: 15px; border: 0px"></td>
          <td style="height: 3px; width: 98px; border: 0px"></td>
          <td style="height: 3px; width: 1px; border: 0px"></td>
          <td style="height: 3px; width: 14px; border: 0px"></td>
          <td style="height: 3px; width: 4px; border: 0px"></td>
        </tr>
        <tr style="height: 15px">
          <td style="height: 14px; width: 23px; border: 0px"></td>
          <td style="height: 14px; width: 94px; border: 0px"></td>
          <td style="height: 14px; width: 4px; border: 0px"></td>
          <td style="height: 14px; width: 23px; border: 0px"></td>
          <td style="height: 14px; width: 49px; border: 0px"></td>
          <td style="height: 14px; width: 26px; border: 0px"></td>
          <td style="height: 14px; width: 19px; border: 0px"></td>
          <td style="height: 14px; width: 4px; border: 0px"></td>
          <td style="height: 14px; width: 56px; border: 0px"></td>
          <td style="height: 14px; width: 1px; border: 0px"></td>
          <td style="height: 14px; width: 15px; border: 0px"></td>
          <td style="height: 14px; width: 3px; border: 0px"></td>
          <td style="height: 14px; width: 12px; border: 0px"></td>
          <td style="height: 14px; width: 4px; border: 0px"></td>
          <td style="height: 14px; width: 3px; border: 0px"></td>
          <td style="height: 14px; width: 19px; border: 0px"></td>
          <td style="height: 14px; width: 19px; border: 0px"></td>
          <td style="height: 14px; width: 15px; border: 0px"></td>
          <td class="sf7752501" style="width: 12px; height: 14px"></td>
          <td class="s6f01f6ff border-left" style="width: 7px; height: 14px"></td>
          <td
            class="sDetailText1"
            colspan="3"
            rowspan="2"
            style="height: 18px; width: 95px; max-height: 18px; max-width: 95px"
          >
            Tiền mặt tại NH
          </td>
          <td class="sCT_Table_DetailText_MLNS" colspan="3" style="width: 14px; height: 14px">
            {{ model.PaymentMethod == 3 ? 'x' : '' }}
          </td>
          <td class="sd400aa50" style="width: 41px; height: 14px"></td>
          <td style="height: 14px; width: 19px; border: 0px"></td>
          <td style="height: 14px; width: 8px; border: 0px"></td>
          <td style="height: 14px; width: 15px; border: 0px"></td>
          <td style="height: 14px; width: 98px; border: 0px"></td>
          <td style="height: 14px; width: 1px; border: 0px"></td>
          <td style="height: 14px; width: 14px; border: 0px"></td>
          <td style="height: 14px; width: 4px; border: 0px"></td>
        </tr>
        <tr style="height: 3px">
          <td style="height: 2px; width: 23px; border: 0px"></td>
          <td style="height: 2px; width: 94px; border: 0px"></td>
          <td style="height: 2px; width: 4px; border: 0px"></td>
          <td style="height: 2px; width: 23px; border: 0px"></td>
          <td style="height: 2px; width: 49px; border: 0px"></td>
          <td style="height: 2px; width: 26px; border: 0px"></td>
          <td style="height: 2px; width: 19px; border: 0px"></td>
          <td style="height: 2px; width: 4px; border: 0px"></td>
          <td style="height: 2px; width: 56px; border: 0px"></td>
          <td style="height: 2px; width: 1px; border: 0px"></td>
          <td style="height: 2px; width: 15px; border: 0px"></td>
          <td style="height: 2px; width: 3px; border: 0px"></td>
          <td style="height: 2px; width: 12px; border: 0px"></td>
          <td style="height: 2px; width: 4px; border: 0px"></td>
          <td style="height: 2px; width: 3px; border: 0px"></td>
          <td style="height: 2px; width: 19px; border: 0px"></td>
          <td style="height: 2px; width: 19px; border: 0px"></td>
          <td style="height: 2px; width: 15px; border: 0px"></td>
          <td class="sf7752501" style="width: 12px; height: 2px"></td>
          <td class="s6f01f6ff border-left" style="width: 7px; height: 2px"></td>
          <td class="sf672e7c2" style="width: 3px; height: 2px"></td>
          <td class="sf672e7c2" style="width: 8px; height: 2px"></td>
          <td class="sf672e7c2" style="width: 4px; height: 2px"></td>
          <td style="height: 2px; width: 41px; border: 0px"></td>
          <td style="height: 2px; width: 19px; border: 0px"></td>
          <td style="height: 2px; width: 8px; border: 0px"></td>
          <td style="height: 2px; width: 15px; border: 0px"></td>
          <td style="height: 2px; width: 98px; border: 0px"></td>
          <td style="height: 2px; width: 1px; border: 0px"></td>
          <td style="height: 2px; width: 14px; border: 0px"></td>
          <td style="height: 2px; width: 4px; border: 0px"></td>
        </tr>
        <tr style="height: 1px">
          <td style="height: 1px; width: 23px; border: 0px"></td>
          <td style="height: 1px; width: 94px; border: 0px"></td>
          <td style="height: 1px; width: 4px; border: 0px"></td>
          <td style="height: 1px; width: 23px; border: 0px"></td>
          <td style="height: 1px; width: 49px; border: 0px"></td>
          <td style="height: 1px; width: 26px; border: 0px"></td>
          <td style="height: 1px; width: 19px; border: 0px"></td>
          <td style="height: 1px; width: 4px; border: 0px"></td>
          <td style="height: 1px; width: 56px; border: 0px"></td>
          <td style="height: 1px; width: 1px; border: 0px"></td>
          <td style="height: 1px; width: 15px; border: 0px"></td>
          <td style="height: 1px; width: 3px; border: 0px"></td>
          <td style="height: 1px; width: 12px; border: 0px"></td>
          <td style="height: 1px; width: 4px; border: 0px"></td>
          <td style="height: 1px; width: 3px; border: 0px"></td>
          <td style="height: 1px; width: 19px; border: 0px"></td>
          <td style="height: 1px; width: 19px; border: 0px"></td>
          <td style="height: 1px; width: 15px; border: 0px"></td>
          <td class="sf7752501" style="width: 12px; height: 1px"></td>
          <td class="s6f01f6ff border-left" style="width: 7px; height: 1px"></td>
          <td style="height: 1px; width: 34px; border: 0px"></td>
          <td style="height: 1px; width: 38px; border: 0px"></td>
          <td style="height: 1px; width: 23px; border: 0px"></td>
          <td style="height: 1px; width: 3px; border: 0px"></td>
          <td style="height: 1px; width: 8px; border: 0px"></td>
          <td style="height: 1px; width: 4px; border: 0px"></td>
          <td style="height: 1px; width: 41px; border: 0px"></td>
          <td style="height: 1px; width: 19px; border: 0px"></td>
          <td style="height: 1px; width: 8px; border: 0px"></td>
          <td style="height: 1px; width: 15px; border: 0px"></td>
          <td style="height: 1px; width: 98px; border: 0px"></td>
          <td style="height: 1px; width: 1px; border: 0px"></td>
          <td style="height: 1px; width: 14px; border: 0px"></td>
          <td style="height: 1px; width: 4px; border: 0px"></td>
        </tr>
        <tr style="height: 4px">
          <td style="height: 4px; width: 23px; border: 0px"></td>
          <td style="height: 4px; width: 94px; border: 0px"></td>
          <td style="height: 4px; width: 4px; border: 0px"></td>
          <td style="height: 4px; width: 23px; border: 0px"></td>
          <td style="height: 4px; width: 49px; border: 0px"></td>
          <td style="height: 4px; width: 26px; border: 0px"></td>
          <td style="height: 4px; width: 19px; border: 0px"></td>
          <td style="height: 4px; width: 4px; border: 0px"></td>
          <td style="height: 4px; width: 56px; border: 0px"></td>
          <td style="height: 4px; width: 1px; border: 0px"></td>
          <td style="height: 4px; width: 15px; border: 0px"></td>
          <td style="height: 4px; width: 3px; border: 0px"></td>
          <td style="height: 4px; width: 12px; border: 0px"></td>
          <td style="height: 4px; width: 4px; border: 0px"></td>
          <td style="height: 4px; width: 3px; border: 0px"></td>
          <td style="height: 4px; width: 19px; border: 0px"></td>
          <td style="height: 4px; width: 19px; border: 0px"></td>
          <td style="height: 4px; width: 15px; border: 0px"></td>
          <td style="height: 4px; width: 12px; border: 0px"></td>
          <td style="height: 4px; width: 7px; border: 0px"></td>
          <td style="height: 4px; width: 34px; border: 0px"></td>
          <td style="height: 4px; width: 38px; border: 0px"></td>
          <td style="height: 4px; width: 23px; border: 0px"></td>
          <td style="height: 4px; width: 3px; border: 0px"></td>
          <td style="height: 4px; width: 8px; border: 0px"></td>
          <td style="height: 4px; width: 4px; border: 0px"></td>
          <td style="height: 4px; width: 41px; border: 0px"></td>
          <td style="height: 4px; width: 19px; border: 0px"></td>
          <td style="height: 4px; width: 8px; border: 0px"></td>
          <td style="height: 4px; width: 15px; border: 0px"></td>
          <td style="height: 4px; width: 98px; border: 0px"></td>
          <td style="height: 4px; width: 1px; border: 0px"></td>
          <td style="height: 4px; width: 14px; border: 0px"></td>
          <td style="height: 4px; width: 4px; border: 0px"></td>
        </tr>
        <tr style="height: 15px">
          <td
            class="s9bda6bbe company-name-title no-warp"
            colspan="2"
            :style="{fontSize: model.font_size + fontSizeDV}"
          >
            <span>Đơn vị rút dự toán:</span>
          </td>
          <td style="height: 15px; width: 4px; border: 0px"></td>
          <td
            class="s9bda6bbe"
            colspan="30"
            style="height: 15px; width: 593px; max-height: 15px; max-width: 593px"
            :style="{fontSize: model.font_size + fontSizeDV}"
          >
            {{ model.CompanyName }}
          </td>
          <td style="height: 15px; width: 4px; border: 0px"></td>
        </tr>
        <tr style="height: 4px">
          <td style="height: 4px; width: 23px; border: 0px"></td>
          <td style="height: 4px; width: 94px; border: 0px"></td>
          <td style="height: 4px; width: 4px; border: 0px"></td>
          <td style="height: 4px; width: 23px; border: 0px"></td>
          <td style="height: 4px; width: 49px; border: 0px"></td>
          <td style="height: 4px; width: 26px; border: 0px"></td>
          <td style="height: 4px; width: 19px; border: 0px"></td>
          <td style="height: 4px; width: 4px; border: 0px"></td>
          <td style="height: 4px; width: 56px; border: 0px"></td>
          <td style="height: 4px; width: 1px; border: 0px"></td>
          <td style="height: 4px; width: 15px; border: 0px"></td>
          <td style="height: 4px; width: 3px; border: 0px"></td>
          <td style="height: 4px; width: 12px; border: 0px"></td>
          <td style="height: 4px; width: 4px; border: 0px"></td>
          <td style="height: 4px; width: 3px; border: 0px"></td>
          <td style="height: 4px; width: 19px; border: 0px"></td>
          <td style="height: 4px; width: 19px; border: 0px"></td>
          <td style="height: 4px; width: 15px; border: 0px"></td>
          <td style="height: 4px; width: 12px; border: 0px"></td>
          <td style="height: 4px; width: 7px; border: 0px"></td>
          <td style="height: 4px; width: 34px; border: 0px"></td>
          <td style="height: 4px; width: 38px; border: 0px"></td>
          <td style="height: 4px; width: 23px; border: 0px"></td>
          <td style="height: 4px; width: 3px; border: 0px"></td>
          <td style="height: 4px; width: 8px; border: 0px"></td>
          <td style="height: 4px; width: 4px; border: 0px"></td>
          <td style="height: 4px; width: 41px; border: 0px"></td>
          <td style="height: 4px; width: 19px; border: 0px"></td>
          <td style="height: 4px; width: 8px; border: 0px"></td>
          <td style="height: 4px; width: 15px; border: 0px"></td>
          <td style="height: 4px; width: 98px; border: 0px"></td>
          <td style="height: 4px; width: 1px; border: 0px"></td>
          <td style="height: 4px; width: 14px; border: 0px"></td>
          <td style="height: 4px; width: 4px; border: 0px"></td>
        </tr>
        <tr style="height: 19px">
          <td class="s9bda6bbe account-name-title" colspan="33" :style="{fontSize: model.font_size + fontSizeDV}">
            <span>Tài khoản: {{ model.bank_info_code }}</span> &nbsp;&nbsp;&nbsp; Tại KBNN: {{ model.bank_info_name }}
          </td>
          <td style="height: 19px; width: 4px; border: 0px"></td>
        </tr>
        <tr style="height: 1px">
          <td style="height: 1px; width: 23px; border: 0px"></td>
          <td style="height: 1px; width: 94px; border: 0px"></td>
          <td style="height: 1px; width: 4px; border: 0px"></td>
          <td style="height: 1px; width: 23px; border: 0px"></td>
          <td style="height: 1px; width: 49px; border: 0px"></td>
          <td style="height: 1px; width: 26px; border: 0px"></td>
          <td style="height: 1px; width: 19px; border: 0px"></td>
          <td style="height: 1px; width: 4px; border: 0px"></td>
          <td style="height: 1px; width: 56px; border: 0px"></td>
          <td style="height: 1px; width: 1px; border: 0px"></td>
          <td style="height: 1px; width: 15px; border: 0px"></td>
          <td style="height: 1px; width: 3px; border: 0px"></td>
          <td style="height: 1px; width: 12px; border: 0px"></td>
          <td style="height: 1px; width: 4px; border: 0px"></td>
          <td style="height: 1px; width: 3px; border: 0px"></td>
          <td style="height: 1px; width: 19px; border: 0px"></td>
          <td style="height: 1px; width: 19px; border: 0px"></td>
          <td style="height: 1px; width: 15px; border: 0px"></td>
          <td style="height: 1px; width: 12px; border: 0px"></td>
          <td style="height: 1px; width: 7px; border: 0px"></td>
          <td style="height: 1px; width: 34px; border: 0px"></td>
          <td style="height: 1px; width: 38px; border: 0px"></td>
          <td style="height: 1px; width: 23px; border: 0px"></td>
          <td style="height: 1px; width: 3px; border: 0px"></td>
          <td style="height: 1px; width: 8px; border: 0px"></td>
          <td style="height: 1px; width: 4px; border: 0px"></td>
          <td style="height: 1px; width: 41px; border: 0px"></td>
          <td style="height: 1px; width: 19px; border: 0px"></td>
          <td style="height: 1px; width: 8px; border: 0px"></td>
          <td style="height: 1px; width: 15px; border: 0px"></td>
          <td style="height: 1px; width: 98px; border: 0px"></td>
          <td style="height: 1px; width: 1px; border: 0px"></td>
          <td style="height: 1px; width: 14px; border: 0px"></td>
          <td style="height: 1px; width: 4px; border: 0px"></td>
        </tr>
        <tr :class="model.project_code ? 'h-19px' : 'h-31px'">
          <td
            class="s9bda6bbe"
            colspan="33"
            style="white-space: nowrap; max-width: 714px; width: 714px"
            :style="{fontSize: model.font_size + fontSizeDV}"
          >
            <div>
              Tên CTMT, DA:
              {{
                model.project_name
                  ? model.project_name
                  : '................................................................................................................................................................................................'
              }}
              <span v-if="model.project_code">&nbsp;&nbsp; Mã CTMT, DA: {{ model.project_code }}</span>
            </div>
            <div v-if="!model.project_code || model.project_code == ''">
              ...................................................................................... Mã CTMT, DA:
              .........................................................................................................
            </div>
          </td>
          <td :class="model.project_code ? 'h-19px' : 'h-31px'" style="width: 4px; border: 0px"></td>
        </tr>
        <tr style="height: 19px">
          <td
            class="s92554d74"
            colspan="33"
            style="white-space: nowrap; height: 19px; max-width: 714px; width: 714px; max-height: 19px"
            :style="{fontSize: model.font_size + fontSizeDV}"
          >
            Số CKC, HĐK: {{ model.contract_template }} &nbsp;&nbsp; Số CKC, HĐTH: {{ model.contract_perform }}
          </td>
          <td style="height: 19px; width: 4px; border: 0px"></td>
        </tr>
        <tr style="height: 38px">
          <td class="sDetailHeader" colspan="15" style="height: 37px; width: 335px; max-height: 37px; max-width: 335px">
            Nội dung thanh toán
          </td>
          <td class="sDetailHeader1" colspan="3" style="height: 37px; width: 52px; max-height: 37px; max-width: 52px">
            Mã NDKT
          </td>
          <td class="sDetailHeader1" colspan="3" style="height: 37px; width: 52px; max-height: 37px; max-width: 52px">
            Mã chương
          </td>
          <td class="sDetailHeader1" colspan="4" style="height: 37px; width: 71px; max-height: 37px; max-width: 71px">
            Mã ngành KT
          </td>
          <td class="sDetailHeader1" colspan="4" style="height: 37px; width: 71px; max-height: 37px; max-width: 71px">
            Mã nguồn NSNN
          </td>
          <td class="sDetailHeader1" colspan="4" style="height: 37px; width: 127px; max-height: 37px; max-width: 127px">
            Số tiền
          </td>
          <td class="s6f01f6ff" style="width: 4px; height: 37px"></td>
        </tr>
        <tr style="height: 19px">
          <td class="sBC_Table_SubHeader" colspan="15" style="height: 18px; width: 335px">(1)</td>
          <td class="sBC_Table_SubHeader1" colspan="3" style="height: 18px; width: 52px">(2)</td>
          <td class="sBC_Table_SubHeader1" colspan="3" style="height: 18px; width: 52px">(3)</td>
          <td class="sBC_Table_SubHeader1" colspan="4" style="height: 18px; width: 71px">(4)</td>
          <td class="sBC_Table_SubHeader1" colspan="4" style="height: 18px; width: 71px">(5)</td>
          <td class="sBC_Table_SubHeader2" colspan="4" style="height: 18px; width: 127px">(6)</td>
          <td class="sd400aa50" style="width: 4px; height: 18px"></td>
        </tr>
        <template v-for="(item, index) in model.Detail" :key="index">
          <tr style="height: 19px" class="table-row">
            <td
              class="se865e78b"
              :class="{'border-top-none': index == 0}"
              colspan="15"
              style="height: 18px; width: 335px; max-height: 18px; max-width: 335px"
              :style="{fontSize: model.font_size + fontSizeDV}"
            >
              {{ item.description }}
            </td>
            <td
              class="s1f59be16"
              :class="{'border-top-none': index == 0}"
              colspan="3"
              style="height: 18px; width: 52px; max-height: 18px; max-width: 52px"
              :style="{fontSize: model.font_size + fontSizeDV}"
            >
              {{ item.budget_sub_item_code }}
            </td>
            <td
              class="s1f59be16"
              :class="{'border-top-none': index == 0}"
              colspan="3"
              style="height: 18px; width: 52px"
              :style="{fontSize: model.font_size + fontSizeDV}"
            >
              {{ item.budget_chapter_code }}
            </td>
            <td
              class="s1f59be16"
              :class="{'border-top-none': index == 0}"
              colspan="4"
              style="height: 18px; width: 71px"
              :style="{fontSize: model.font_size + fontSizeDV}"
            >
              {{ item.budget_sub_kind_item_code }}
            </td>
            <td
              class="s1f59be16"
              :class="{'border-top-none': index == 0}"
              colspan="4"
              style="height: 18px; width: 71px"
              :style="{fontSize: model.font_size + fontSizeDV}"
            >
              {{ item.budget_source_property_code }}
            </td>
            <td
              class="sacf10bdf"
              :class="{'border-top-none': index == 0}"
              colspan="4"
              style="height: 18px; width: 127px; max-height: 18px; max-width: 127px"
              :style="{fontSize: model.font_size + fontSizeDV}"
            >
              {{
                $ms.format.formatData(item.amount, {
                  formatType: 2,
                })
              }}
            </td>
            <td class="sd400aa50" style="width: 4px; height: 18px"></td>
          </tr>
        </template>
        <tr style="height: 18px" v-if="model.use_add_info && model.add_info">
          <td
            class="sddaff93d"
            colspan="15"
            style="height: 17px; width: 335px; max-height: 17px; max-width: 335px"
            :style="{fontSize: model.font_size + fontSizeDV}"
          >
            {{ model.add_info }}
          </td>
          <td class="sae4197fc" colspan="3" style="height: 17px; width: 52px"></td>
          <td class="sae4197fc" colspan="3" style="height: 17px; width: 52px"></td>
          <td class="sae4197fc" colspan="4" style="height: 17px; width: 71px"></td>
          <td class="sae4197fc" colspan="4" style="height: 17px; width: 71px"></td>
          <td class="scb139826" colspan="4" style="height: 17px; width: 127px; max-height: 17px; max-width: 127px">
            &nbsp;
          </td>
          <td class="sfae43ad5" style="width: 4px; height: 17px"></td>
        </tr>
        <tr style="height: 32px" v-if="model.use_sec">
          <td
            class="s8c44c6e9"
            colspan="15"
            style="height: 31px; width: 335px; max-height: 31px; max-width: 335px"
            :style="{fontSize: model.font_size + fontSizeDV}"
          >
            {{ model.add_sec_info }}:
            {{ model.CompanyName }}
            Số CMND: {{ model.paramIdentification_number ? model.paramIdentification_number : '.................' }} Cấp
            ngày: {{ model.issueDate ? model.issueDate : '............' }} Nơi cấp:
            {{ model.issueBy ? model.issueBy : '..............' }}
          </td>
          <td class="s94387e26" colspan="3" style="height: 31px; width: 52px"></td>
          <td class="s94387e26" colspan="3" style="height: 31px; width: 52px"></td>
          <td class="s94387e26" colspan="4" style="height: 31px; width: 71px"></td>
          <td class="s94387e26" colspan="4" style="height: 31px; width: 71px"></td>
          <td class="s3cdcfc03" colspan="4" style="height: 31px; width: 127px; max-height: 31px; max-width: 127px">
            &nbsp;
          </td>
          <td class="sfae43ad5" style="width: 4px; height: 31px"></td>
        </tr>
        <tr style="height: 23px" class="table-row">
          <td
            class="s9e5d76c9"
            colspan="29"
            style="height: 22px; width: 585px; max-height: 22px; max-width: 585px; padding: 0px 0px 0px 0px"
            :style="{fontSize: model.font_size + fontSizeDV}"
          >
            Tổng cộng
          </td>
          <td
            class="s075e0772"
            colspan="4"
            style="height: 22px; width: 127px; max-height: 22px; max-width: 127px"
            :style="{fontSize: model.font_size + fontSizeDV}"
          >
            {{
              $ms.format.formatData(model.total_amonut, {
                formatType: 2,
              })
            }}
          </td>
          <td class="s6f01f6ff" style="width: 4px; height: 22px"></td>
        </tr>
        <tr style="height: 15px" class="footer-report">
          <td class="s07b556ce" style="width: 23px; height: 14px"></td>
          <td class="s07b556ce" style="width: 94px; height: 14px"></td>
          <td class="s07b556ce" style="width: 4px; height: 14px"></td>
          <td class="s07b556ce" style="width: 23px; height: 14px"></td>
          <td class="s07b556ce" style="width: 49px; height: 14px"></td>
          <td class="s07b556ce" style="width: 26px; height: 14px"></td>
          <td class="s07b556ce" style="width: 19px; height: 14px"></td>
          <td class="s07b556ce" style="width: 4px; height: 14px"></td>
          <td class="s07b556ce" style="width: 56px; height: 14px"></td>
          <td class="s07b556ce" style="width: 1px; height: 14px"></td>
          <td class="s07b556ce" style="width: 15px; height: 14px"></td>
          <td class="s07b556ce" style="width: 3px; height: 14px"></td>
          <td class="s07b556ce" style="width: 12px; height: 14px"></td>
          <td class="s07b556ce" style="width: 4px; height: 14px"></td>
          <td class="s07b556ce" style="width: 3px; height: 14px"></td>
          <td class="s07b556ce" style="width: 19px; height: 14px"></td>
          <td class="s07b556ce" style="width: 19px; height: 14px"></td>
          <td class="s07b556ce" style="width: 15px; height: 14px"></td>
          <td class="s07b556ce" style="width: 12px; height: 14px"></td>
          <td class="s07b556ce" style="width: 7px; height: 14px"></td>
          <td class="s07b556ce" style="width: 34px; height: 14px"></td>
          <td class="s07b556ce" style="width: 38px; height: 14px"></td>
          <td class="s07b556ce" style="width: 23px; height: 14px"></td>
          <td class="s07b556ce" style="width: 3px; height: 14px"></td>
          <td class="s07b556ce" style="width: 8px; height: 14px"></td>
          <td class="s07b556ce" style="width: 4px; height: 14px"></td>
          <td class="s07b556ce" style="width: 41px; height: 14px"></td>
          <td class="s07b556ce" style="width: 19px; height: 14px"></td>
          <td class="scf32fa05" style="width: 8px; height: 14px"></td>
          <td class="scf32fa05" style="width: 15px; height: 14px"></td>
          <td class="scf32fa05" style="width: 98px; height: 14px"></td>
          <td class="scf32fa05" style="width: 1px; height: 14px"></td>
          <td class="scf32fa05" style="width: 14px; height: 14px"></td>
          <td style="height: 14px; width: 4px; border: 0px"></td>
        </tr>
        <tr style="height: 19px">
          <td
            class="s9bda6bbe"
            colspan="27"
            style="height: 19px; width: 559px; max-height: 19px; max-width: 559px"
            :style="{fontSize: model.font_size + fontSizeDV}"
          >
            <span>Tổng số tiền ghi bằng chữ: {{ model.total_amonut_text }}</span>
          </td>
          <td class="s584be2f9" style="width: 19px; height: 18px"></td>
          <td class="sDetailHeader2" colspan="5" style="height: 18px; width: 135px; max-height: 18px; max-width: 135px">
            PHẦN KBNN GHI
          </td>
          <td class="sd400aa50" style="width: 4px; height: 18px"></td>
        </tr>
        <tr style="height: 15px">
          <td
            class="s9bda6bbe"
            colspan="27"
            rowspan="2"
            style="height: 19px; width: 559px; max-height: 19px; max-width: 559px"
            :style="{fontSize: model.font_size + fontSizeDV}"
          >
            <span>Đơn vị nhận tiền: {{ model.organization_name }}</span>
          </td>
          <td class="sf7752501" style="width: 19px; height: 14px"></td>
          <td class="sDetailText3" colspan="5" style="height: 14px; width: 135px; max-height: 14px; max-width: 135px">
            Nợ TK: {{ model.debit_account_1 }}
          </td>
          <td class="s6f01f6ff" style="width: 4px; height: 14px"></td>
        </tr>
        <tr style="height: 4px">
          <td class="sf7752501" style="width: 19px; height: 4px"></td>
          <td
            class="sDetailText4"
            colspan="5"
            rowspan="2"
            style="height: 15px; width: 136px; max-height: 15px; max-width: 136px"
          >
            Có TK: {{ model.credit_account_1 }}
          </td>
          <td class="s6f01f6ff" style="width: 4px; height: 4px"></td>
        </tr>
        <tr style="height: 11px">
          <td
            class="s9bda6bbe"
            colspan="27"
            rowspan="2"
            style="height: 19px; width: 559px; max-height: 19px; max-width: 559px"
            :style="{fontSize: model.font_size + fontSizeDV}"
          >
            <span>Địa chỉ: {{ model.organization_address }}</span>
          </td>
          <td class="sf7752501" style="width: 19px; height: 11px"></td>
          <td class="s6f01f6ff" style="width: 4px; height: 11px"></td>
        </tr>
        <tr style="height: 8px">
          <td class="sf7752501" style="width: 19px; height: 8px"></td>
          <td
            class="sDetailText4"
            colspan="5"
            rowspan="2"
            style="height: 15px; width: 136px; max-height: 15px; max-width: 136px"
          >
            Nợ TK: {{ model.debit_account_2 }}
          </td>
          <td class="s6f01f6ff" style="width: 4px; height: 8px"></td>
        </tr>
        <tr style="height: 7px">
          <td
            class="s9bda6bbe"
            colspan="27"
            rowspan="2"
            style="height: 19px; width: 559px; max-height: 19px; max-width: 559px"
            :style="{fontSize: model.font_size + fontSizeDV}"
          >
            <span>Tài khoản: {{ model.accounting_object_bank_account }}</span>
          </td>
          <td class="sf7752501" style="width: 19px; height: 7px"></td>
          <td class="s6f01f6ff" style="width: 4px; height: 7px"></td>
        </tr>
        <tr style="height: 12px">
          <td class="sf7752501" style="width: 19px; height: 12px"></td>
          <td
            class="sDetailText4"
            colspan="5"
            rowspan="2"
            style="height: 15px; width: 136px; max-height: 15px; max-width: 136px"
          >
            Có TK: {{ model.credit_account_2 }}
          </td>
          <td class="s6f01f6ff" style="width: 4px; height: 12px"></td>
        </tr>
        <tr style="height: 3px">
          <td
            class="s9bda6bbe"
            colspan="27"
            rowspan="4"
            style="height: 19px; width: 559px; max-height: 19px; max-width: 559px"
            :style="{fontSize: model.font_size + fontSizeDV}"
          >
            <span>Tại KBNN (NH): {{ model.accounting_object_bank_name }}</span>
          </td>
          <td class="sf7752501" style="width: 19px; height: 3px"></td>
          <td class="s6f01f6ff" style="width: 4px; height: 3px"></td>
        </tr>
        <tr style="height: 1px">
          <td class="sf7752501" style="width: 19px; height: 1px"></td>
          <td
            class="sDetailText4"
            colspan="5"
            rowspan="2"
            style="height: 15px; width: 136px; max-height: 15px; max-width: 136px"
          >
            Nợ TK: {{ model.debit_account_3 }}
          </td>
          <td class="s6f01f6ff" style="width: 4px; height: 1px"></td>
        </tr>
        <tr style="height: 14px">
          <td class="sf7752501" style="width: 19px; height: 14px"></td>
          <td class="s6f01f6ff" style="width: 4px; height: 14px"></td>
        </tr>
        <tr style="height: 1px">
          <td class="sf7752501" style="width: 19px; height: 1px"></td>
          <td
            class="sDetailText4"
            colspan="5"
            rowspan="2"
            style="height: 15px; width: 136px; max-height: 15px; max-width: 136px"
          >
            Có TK: {{ model.credit_account_3 }}
          </td>
          <td class="s6f01f6ff" style="width: 4px; height: 1px"></td>
        </tr>
        <tr style="height: 14px">
          <td
            class="s9bda6bbe no-warp"
            colspan="27"
            rowspan="3"
            style="height: 18px; width: 559px; max-height: 18px; max-width: 559px"
            :style="{fontSize: model.font_size + fontSizeDV}"
          >
            <span
              >Hoặc người nhận tiền:
              ..................................................................................................................</span
            >
          </td>
          <td class="sf7752501" style="width: 19px; height: 14px"></td>
          <td class="s6f01f6ff" style="width: 4px; height: 14px"></td>
        </tr>
        <tr style="height: 1px">
          <td style="height: 1px; width: 19px; border: 0px"></td>
          <td style="height: 1px; width: 8px; border: 0px" class="border-left"></td>
          <td style="height: 1px; width: 15px; border: 0px"></td>
          <td style="height: 1px; width: 98px; border: 0px"></td>
          <td style="height: 1px; width: 1px; border: 0px"></td>
          <td style="height: 1px; width: 14px; border: 0px" class="border-right"></td>
          <td style="height: 1px; width: 4px; border: 0px"></td>
        </tr>
        <tr style="height: 3px">
          <td class="sf7752501" style="width: 19px; height: 3px"></td>
          <td
            class="sDetailText4"
            colspan="5"
            rowspan="2"
            style="height: 15px; width: 136px; max-height: 15px; max-width: 136px"
          >
            Mã ĐBHC: {{ model.tax_payer_organization_code }}
          </td>
          <td class="s6f01f6ff" style="width: 4px; height: 3px"></td>
        </tr>
        <tr style="height: 12px">
          <td
            class="s9bda6bbe no-warp"
            colspan="5"
            rowspan="3"
            style="height: 19px; width: 193px; max-height: 19px; max-width: 193px"
            :style="{fontSize: model.font_size + fontSizeDV}"
          >
            <span>Số CMND: ..........................</span>
          </td>
          <td
            class="s9bda6bbe no-warp"
            colspan="11"
            rowspan="3"
            style="height: 19px; width: 162px; max-height: 19px; max-width: 162px"
            :style="{fontSize: model.font_size + fontSizeDV}"
          >
            <span>Cấp ngày: ......................</span>
          </td>
          <td
            class="s9bda6bbe no-warp"
            colspan="11"
            rowspan="3"
            style="height: 19px; width: 204px; max-height: 19px; max-width: 204px"
            :style="{fontSize: model.font_size + fontSizeDV}"
          >
            <span>Nơi cấp: .........................</span>
          </td>
          <td class="sf7752501" style="width: 19px; height: 12px"></td>
          <td class="s6f01f6ff" style="width: 4px; height: 12px"></td>
        </tr>
        <tr style="height: 3px">
          <td class="sf7752501" style="width: 19px; height: 3px"></td>
          <td class="sDetailText5" colspan="5" style="width: 136px; height: 3px"></td>
          <td class="s6f01f6ff" style="width: 4px; height: 3px"></td>
        </tr>
        <tr style="height: 4px">
          <td style="height: 3px; width: 19px; border: 0px"></td>
          <td class="s07b556ce" style="width: 8px; height: 3px"></td>
          <td class="s07b556ce" style="width: 15px; height: 3px"></td>
          <td class="s07b556ce" style="width: 98px; height: 3px"></td>
          <td class="s07b556ce" style="width: 1px; height: 3px"></td>
          <td class="s07b556ce" style="width: 14px; height: 3px"></td>
          <td style="height: 3px; width: 4px; border: 0px"></td>
        </tr>
        <tr style="height: 26px" class="footer-report-org">
          <td style="height: 26px; width: 23px; border: 0px"></td>
          <td style="height: 26px; width: 94px; border: 0px"></td>
          <td style="height: 26px; width: 4px; border: 0px"></td>
          <td style="height: 26px; width: 23px; border: 0px"></td>
          <td style="height: 26px; width: 49px; border: 0px"></td>
          <td style="height: 26px; width: 26px; border: 0px"></td>
          <td style="height: 26px; width: 19px; border: 0px"></td>
          <td style="height: 26px; width: 4px; border: 0px"></td>
          <td style="height: 26px; width: 56px; border: 0px"></td>
          <td style="height: 26px; width: 1px; border: 0px"></td>
          <td style="height: 26px; width: 15px; border: 0px"></td>
          <td style="height: 26px; width: 3px; border: 0px"></td>
          <td style="height: 26px; width: 12px; border: 0px"></td>
          <td style="height: 26px; width: 4px; border: 0px"></td>
          <td style="height: 26px; width: 3px; border: 0px"></td>
          <td style="height: 26px; width: 19px; border: 0px"></td>
          <td style="height: 26px; width: 19px; border: 0px"></td>
          <td style="height: 26px; width: 15px; border: 0px"></td>
          <td style="height: 26px; width: 12px; border: 0px"></td>
          <td style="height: 26px; width: 7px; border: 0px"></td>
          <td style="height: 26px; width: 34px; border: 0px"></td>
          <td style="height: 26px; width: 38px; border: 0px"></td>
          <td style="height: 26px; width: 23px; border: 0px"></td>
          <td style="height: 26px; width: 3px; border: 0px"></td>
          <td style="height: 26px; width: 8px; border: 0px"></td>
          <td style="height: 26px; width: 4px; border: 0px"></td>
          <td style="height: 26px; width: 41px; border: 0px"></td>
          <td style="height: 26px; width: 19px; border: 0px"></td>
          <td style="height: 26px; width: 8px; border: 0px"></td>
          <td style="height: 26px; width: 15px; border: 0px"></td>
          <td style="height: 26px; width: 98px; border: 0px"></td>
          <td style="height: 26px; width: 1px; border: 0px"></td>
          <td style="height: 26px; width: 14px; border: 0px"></td>
          <td style="height: 26px; width: 4px; border: 0px"></td>
        </tr>
        <tr style="height: 19px">
          <td style="height: 19px; width: 23px; border: 0px"></td>
          <td class="sBC_Sign_Date" colspan="7" style="height: 19px; width: 219px; max-height: 19px; max-width: 219px">
            Ngày ... tháng ... năm ...
          </td>
          <td style="height: 19px; width: 56px; border: 0px"></td>
          <td style="height: 19px; width: 1px; border: 0px"></td>
          <td style="height: 19px; width: 15px; border: 0px"></td>
          <td style="height: 19px; width: 3px; border: 0px"></td>
          <td style="height: 19px; width: 12px; border: 0px"></td>
          <td class="sBC_Sign_Date" colspan="18" style="height: 19px; width: 370px; max-height: 19px; max-width: 370px">
            {{ model.ref_date }}
          </td>
          <td style="height: 19px; width: 1px; border: 0px"></td>
          <td style="height: 19px; width: 14px; border: 0px"></td>
          <td style="height: 19px; width: 4px; border: 0px"></td>
        </tr>
        <tr style="height: 19px">
          <td style="height: 19px; width: 23px; border: 0px"></td>
          <td class="sCT_Sign_Title" colspan="7" style="height: 19px; width: 219px; max-height: 19px; max-width: 219px">
            Người nhận tiền
          </td>
          <td style="height: 19px; width: 56px; border: 0px"></td>
          <td style="height: 19px; width: 1px; border: 0px"></td>
          <td style="height: 19px; width: 15px; border: 0px"></td>
          <td style="height: 19px; width: 3px; border: 0px"></td>
          <td style="height: 19px; width: 12px; border: 0px"></td>
          <td
            class="sCT_Sign_Title"
            colspan="11"
            style="height: 19px; width: 177px; max-height: 19px; max-width: 177px"
          >
            {{ model.CompanyChiefAccountantTitle }}
          </td>
          <td class="sCT_Sign_Title" colspan="7" style="height: 19px; width: 193px; max-height: 19px; max-width: 193px">
            {{ model.CompanyDirectorTitle }}
          </td>
          <td style="height: 19px; width: 1px; border: 0px"></td>
          <td style="height: 19px; width: 14px; border: 0px"></td>
          <td style="height: 19px; width: 4px; border: 0px"></td>
        </tr>
        <tr style="height: 15px">
          <td style="height: 15px; width: 23px; border: 0px"></td>
          <td
            class="sCT_Sign_SubTitle"
            colspan="7"
            rowspan="2"
            style="height: 19px; width: 219px; max-height: 19px; max-width: 219px"
          >
            (Ký, ghi rõ họ tên)
          </td>
          <td style="height: 15px; width: 56px; border: 0px"></td>
          <td style="height: 15px; width: 1px; border: 0px"></td>
          <td style="height: 15px; width: 15px; border: 0px"></td>
          <td style="height: 15px; width: 3px; border: 0px"></td>
          <td style="height: 15px; width: 12px; border: 0px"></td>
          <td
            class="sCT_Sign_SubTitle"
            colspan="11"
            rowspan="2"
            style="height: 19px; width: 177px; max-height: 19px; max-width: 177px"
          >
            (Ký, ghi họ tên)
          </td>
          <td
            class="sCT_Sign_SubTitle1"
            colspan="7"
            style="height: 15px; width: 193px; max-height: 15px; max-width: 193px"
          >
            (Ký, ghi họ tên, đóng dấu)
          </td>
          <td style="height: 15px; width: 1px; border: 0px"></td>
          <td style="height: 15px; width: 14px; border: 0px"></td>
          <td style="height: 15px; width: 4px; border: 0px"></td>
        </tr>
        <tr style="height: 4px">
          <td style="height: 4px; width: 23px; border: 0px"></td>
          <td style="height: 4px; width: 56px; border: 0px"></td>
          <td style="height: 4px; width: 1px; border: 0px"></td>
          <td style="height: 4px; width: 15px; border: 0px"></td>
          <td style="height: 4px; width: 3px; border: 0px"></td>
          <td style="height: 4px; width: 12px; border: 0px"></td>
          <td style="height: 4px; width: 8px; border: 0px"></td>
          <td style="height: 4px; width: 4px; border: 0px"></td>
          <td style="height: 4px; width: 41px; border: 0px"></td>
          <td style="height: 4px; width: 19px; border: 0px"></td>
          <td style="height: 4px; width: 8px; border: 0px"></td>
          <td style="height: 4px; width: 15px; border: 0px"></td>
          <td style="height: 4px; width: 98px; border: 0px"></td>
          <td style="height: 4px; width: 1px; border: 0px"></td>
          <td style="height: 4px; width: 14px; border: 0px"></td>
          <td style="height: 4px; width: 4px; border: 0px"></td>
        </tr>
        <tr style="height: 86px">
          <td style="height: 86px; width: 23px; border: 0px"></td>
          <td style="height: 86px; width: 94px; border: 0px"></td>
          <td style="height: 86px; width: 4px; border: 0px"></td>
          <td style="height: 86px; width: 23px; border: 0px"></td>
          <td style="height: 86px; width: 49px; border: 0px"></td>
          <td style="height: 86px; width: 26px; border: 0px"></td>
          <td style="height: 86px; width: 19px; border: 0px"></td>
          <td style="height: 86px; width: 4px; border: 0px"></td>
          <td style="height: 86px; width: 56px; border: 0px"></td>
          <td style="height: 86px; width: 1px; border: 0px"></td>
          <td style="height: 86px; width: 15px; border: 0px"></td>
          <td style="height: 86px; width: 3px; border: 0px"></td>
          <td style="height: 86px; width: 12px; border: 0px"></td>
          <td style="height: 86px; width: 4px; border: 0px"></td>
          <td style="height: 86px; width: 3px; border: 0px"></td>
          <td style="height: 86px; width: 19px; border: 0px"></td>
          <td style="height: 86px; width: 19px; border: 0px"></td>
          <td style="height: 86px; width: 15px; border: 0px"></td>
          <td style="height: 86px; width: 12px; border: 0px"></td>
          <td style="height: 86px; width: 7px; border: 0px"></td>
          <td style="height: 86px; width: 34px; border: 0px"></td>
          <td style="height: 86px; width: 38px; border: 0px"></td>
          <td style="height: 86px; width: 23px; border: 0px"></td>
          <td style="height: 86px; width: 3px; border: 0px"></td>
          <td style="height: 86px; width: 8px; border: 0px"></td>
          <td style="height: 86px; width: 4px; border: 0px"></td>
          <td style="height: 86px; width: 41px; border: 0px"></td>
          <td style="height: 86px; width: 19px; border: 0px"></td>
          <td style="height: 86px; width: 8px; border: 0px"></td>
          <td style="height: 86px; width: 15px; border: 0px"></td>
          <td style="height: 86px; width: 98px; border: 0px"></td>
          <td style="height: 86px; width: 1px; border: 0px"></td>
          <td style="height: 86px; width: 14px; border: 0px"></td>
          <td style="height: 86px; width: 4px; border: 0px"></td>
        </tr>
        <tr style="height: 23px">
          <td style="height: 23px; width: 23px; border: 0px"></td>
          <td style="height: 23px; width: 94px; border: 0px"></td>
          <td style="height: 23px; width: 4px; border: 0px"></td>
          <td style="height: 23px; width: 23px; border: 0px"></td>
          <td style="height: 23px; width: 49px; border: 0px"></td>
          <td style="height: 23px; width: 26px; border: 0px"></td>
          <td style="height: 23px; width: 19px; border: 0px"></td>
          <td style="height: 23px; width: 4px; border: 0px"></td>
          <td style="height: 23px; width: 56px; border: 0px"></td>
          <td style="height: 23px; width: 1px; border: 0px"></td>
          <td style="height: 23px; width: 15px; border: 0px"></td>
          <td style="height: 23px; width: 3px; border: 0px"></td>
          <td style="height: 23px; width: 12px; border: 0px"></td>
          <td
            class="sCT_Sign_People"
            editable="144;Text"
            colspan="11"
            style="height: 23px; width: 177px; max-height: 23px; max-width: 177px"
          >
            {{ model.CompanyChiefAccountant }}
          </td>
          <td
            class="sCT_Sign_People"
            editable="145;Text"
            colspan="7"
            style="height: 23px; width: 193px; max-height: 23px; max-width: 193px"
          >
            {{ model.CompanyDirector }}
          </td>
          <td style="height: 23px; width: 1px; border: 0px"></td>
          <td style="height: 23px; width: 14px; border: 0px"></td>
          <td style="height: 23px; width: 4px; border: 0px"></td>
        </tr>
        <tr style="height: 4px" class="footer-report-KB">
          <td style="height: 4px; width: 23px; border: 0px"></td>
          <td style="height: 4px; width: 94px; border: 0px"></td>
          <td style="height: 4px; width: 4px; border: 0px"></td>
          <td style="height: 4px; width: 23px; border: 0px"></td>
          <td style="height: 4px; width: 49px; border: 0px"></td>
          <td style="height: 4px; width: 26px; border: 0px"></td>
          <td style="height: 4px; width: 19px; border: 0px"></td>
          <td style="height: 4px; width: 4px; border: 0px"></td>
          <td style="height: 4px; width: 56px; border: 0px"></td>
          <td style="height: 4px; width: 1px; border: 0px"></td>
          <td style="height: 4px; width: 15px; border: 0px"></td>
          <td style="height: 4px; width: 3px; border: 0px"></td>
          <td style="height: 4px; width: 12px; border: 0px"></td>
          <td style="height: 4px; width: 4px; border: 0px"></td>
          <td style="height: 4px; width: 3px; border: 0px"></td>
          <td style="height: 4px; width: 19px; border: 0px"></td>
          <td style="height: 4px; width: 19px; border: 0px"></td>
          <td style="height: 4px; width: 15px; border: 0px"></td>
          <td style="height: 4px; width: 12px; border: 0px"></td>
          <td style="height: 4px; width: 7px; border: 0px"></td>
          <td style="height: 4px; width: 34px; border: 0px"></td>
          <td style="height: 4px; width: 38px; border: 0px"></td>
          <td style="height: 4px; width: 23px; border: 0px"></td>
          <td style="height: 4px; width: 3px; border: 0px"></td>
          <td style="height: 4px; width: 8px; border: 0px"></td>
          <td style="height: 4px; width: 4px; border: 0px"></td>
          <td style="height: 4px; width: 41px; border: 0px"></td>
          <td style="height: 4px; width: 19px; border: 0px"></td>
          <td style="height: 4px; width: 8px; border: 0px"></td>
          <td style="height: 4px; width: 15px; border: 0px"></td>
          <td style="height: 4px; width: 98px; border: 0px"></td>
          <td style="height: 4px; width: 1px; border: 0px"></td>
          <td style="height: 4px; width: 14px; border: 0px"></td>
          <td style="height: 4px; width: 4px; border: 0px"></td>
        </tr>
        <tr style="height: 19px">
          <td class="sBC_Sign_Org" colspan="33" style="height: 19px; width: 714px; max-height: 19px; max-width: 714px">
            KHO BẠC NHÀ NƯỚC
          </td>
          <td style="height: 19px; width: 4px; border: 0px"></td>
        </tr>
        <tr style="height: 19px">
          <td class="sSignerDate" colspan="33" style="height: 19px; width: 714px; max-height: 19px; max-width: 714px">
            Ngày ...... tháng ...... năm ......
          </td>
          <td style="height: 19px; width: 4px; border: 0px"></td>
        </tr>
        <tr style="height: 18px">
          <td class="sBC_Sign_Title" colspan="6" style="height: 18px; width: 219px; max-height: 18px; max-width: 219px">
            Thủ quỹ
          </td>
          <td class="sBC_Sign_Title" colspan="8" style="height: 18px; width: 114px; max-height: 18px; max-width: 114px">
            Kế toán
          </td>
          <td
            class="sBC_Sign_Title"
            colspan="12"
            style="height: 18px; width: 185px; max-height: 18px; max-width: 185px"
          >
            Kế toán trưởng
          </td>
          <td
            class="sBC_Sign_Title1"
            colspan="7"
            style="height: 18px; width: 196px; max-height: 18px; max-width: 196px"
          >
            Giám đốc
          </td>
          <td style="height: 18px; width: 4px; border: 0px"></td>
        </tr>
        <tr style="height: 1px">
          <td style="height: 1px; width: 23px; border: 0px"></td>
          <td style="height: 1px; width: 94px; border: 0px"></td>
          <td style="height: 1px; width: 4px; border: 0px"></td>
          <td style="height: 1px; width: 23px; border: 0px"></td>
          <td style="height: 1px; width: 49px; border: 0px"></td>
          <td style="height: 1px; width: 26px; border: 0px"></td>
          <td style="height: 1px; width: 19px; border: 0px"></td>
          <td style="height: 1px; width: 4px; border: 0px"></td>
          <td style="height: 1px; width: 56px; border: 0px"></td>
          <td style="height: 1px; width: 1px; border: 0px"></td>
          <td style="height: 1px; width: 15px; border: 0px"></td>
          <td style="height: 1px; width: 3px; border: 0px"></td>
          <td style="height: 1px; width: 12px; border: 0px"></td>
          <td style="height: 1px; width: 4px; border: 0px"></td>
          <td style="height: 1px; width: 3px; border: 0px"></td>
          <td style="height: 1px; width: 19px; border: 0px"></td>
          <td style="height: 1px; width: 19px; border: 0px"></td>
          <td style="height: 1px; width: 15px; border: 0px"></td>
          <td style="height: 1px; width: 12px; border: 0px"></td>
          <td style="height: 1px; width: 7px; border: 0px"></td>
          <td style="height: 1px; width: 34px; border: 0px"></td>
          <td style="height: 1px; width: 38px; border: 0px"></td>
          <td style="height: 1px; width: 23px; border: 0px"></td>
          <td style="height: 1px; width: 3px; border: 0px"></td>
          <td style="height: 1px; width: 8px; border: 0px"></td>
          <td style="height: 1px; width: 4px; border: 0px"></td>
          <td style="height: 1px; width: 41px; border: 0px"></td>
          <td style="height: 1px; width: 19px; border: 0px"></td>
          <td style="height: 1px; width: 8px; border: 0px"></td>
          <td style="height: 1px; width: 15px; border: 0px"></td>
          <td style="height: 1px; width: 98px; border: 0px"></td>
          <td style="height: 1px; width: 1px; border: 0px"></td>
          <td style="height: 1px; width: 14px; border: 0px"></td>
          <td style="height: 1px; width: 4px; border: 0px"></td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import msDynamicPopup from '@/components/popup/MsDynamicPopup.vue';
import basePopup from '@/views/base/basePopup';
import msGridEditor from '@/components/gridEditor/MsGridEditor.vue';
import msGridViewer from '@/components/gridViewer/MsGridViewer.vue';
import {defineComponent, onMounted, computed, reactive, ref, getCurrentInstance, watch} from 'vue';
import {mapGetters} from 'vuex';
import {ModuleContext} from '@/stores/moduleConst';
import {useCacheAccountingObjectComboConfig} from '@/commons/combobox/cacheCombo/cacheAccountingObjectComboConfig.js';
import {useCacheBudgetItemComboConfig} from '@/commons/combobox/cacheCombo/cacheBudgetItemComboConfig.js';
import {useCacheBudgetSourceComboConfig} from '@/commons/combobox/cacheCombo/cacheBudgetSourceComboConfig.js';
import {useCacheBudgetSourcePropertyComboConfig} from '@/commons/combobox/cacheCombo/cacheBudgetSourcePropertyComboConfig.js';
export default {
  components: {
    msDynamicPopup,
    msGridEditor,
    msGridViewer,
  },
  extends: basePopup,
  name: 'C202aOffline',
  props: {
    dataReport: {
      default: {},
      type: Object,
    },
  },
  computed: {
    ...mapGetters({
      postedDate: ModuleContext + '/PostedDate',
    }),
  },

  setup(props) {
    const {proxy} = getCurrentInstance();
    const dbOptions = ref([]);
    onMounted(() => {
      dbOptions.value = {...proxy.$store.state.dbOption.dbOptions};
      proxy.getVoucherReportData();
    });

    const model = ref({
      CompanyName: '...............................', // dbOption
      bank_account: '...............................',
      bank_name: '...............................',
      project_name: '', // Tên CTMT,DA
      project_code: '', // Mã CTMT,DA
      contract_template: '..........................................', //Số CKC, HĐK
      contract_perform:
        '........................................................................................................................', // Số CKC, HĐTH
      ref_no: '.......', // số ct
      posted_year: 0, //Năm NS
      cash_withdraw_type_id: 0, // Thực chi cash_withdraw_type_id = 6 , ạm ứng cash_withdraw_type_id in (2,3)
      PaymentMethod: 1, // 0 - Chuyển khoản , 2 - Tiền mặt tại KB, 3 - Tiền mặt tài NH
      Detail: [
        {
          description: '', // Diễn giải
          budget_source_property_name: '', // ? vào cột nội dung chi tiết khi v_show_addrow = 1
          budget_sub_item_code: '', // Mã NDKT
          budget_chapter_code: '', // Mã chương
          budget_sub_kind_item_code: '', // Mã ngày KT
          budget_source_property_code: '', // Mã nguồn NSNN
          amount: 0, // số tiền
        },
      ],
      total_amonut: 0, // Tổng số tiền
      total_amonut_text: '...............................', // Số tiền chữ
      organization_name: '...............................', // Đơn vị nhận tiền
      organization_address: '...............................', //Địa chỉ
      accounting_object_bank_account: '...............................', //Tài khoản
      accounting_object_bank_name: '...............................', //Tại KBNN (NH)
      accounting_object_name2: '', //Hoặc người nhận tiền (accounting_object_name2)
      paramIdentification_number: '', //Số CMND
      issueDate: '', //Cấp ngày
      issueBy: '', //Nơi cấp
      debit_account_1: '...............................', //Nợ TK 1 //...............................
      credit_account_1: '...............................', //Có TK 1
      debit_account_2: '...............................', // Nợ TK 2
      credit_account_2: '...............................', // Có TK 2
      debit_account_3: '...............................', // Nợ TK 3
      credit_account_3: '...............................', // Có TK 3
      tax_payer_organization_code: '.........................', //Mã ĐBHC
      ref_date: 'Ngày ... tháng ... năm ....', // Ngày chứng từ  - Ngày / Tháng / Năm - Theo config
      CompanyChiefAccountantTitle: '', // Lấy trong dbOption
      CompanyChiefAccountant: '', // Người ký Kế toán trưởng,
      CompanyDirectorTitle: '', // Lấy trong dbOption
      CompanyDirector: '', // Người ký Thủ trưởng đơn vị,
      use_add_info: false,
      use_sec: false,
      add_info: '',
      add_sec_info: '',
      bank_info_code: '', // Mã tk chi
      bank_info_name: '', // Tên tk chi
      accounting_object_name: '', // Thông tin cấp sec
      accounting_object_id: '', // id cấp séc
      has_font_size: false,
      font_size: 10,
      payment_content: 'description',
      journal_memo: '',
    });

    const fontSizeDV = ref('pt');
    const {accountingObjectCombo} = useCacheAccountingObjectComboConfig();
    const {cacheBudgetItemComboConfig, cacheBudgetSubItemComboConfig} = useCacheBudgetItemComboConfig();
    const {cacheBudgetSourceComboConfig} = useCacheBudgetSourceComboConfig();
    const {cacheBudgetSourcePropertyComboConfig} = useCacheBudgetSourcePropertyComboConfig();

    const isNullOrEmpty = value => {
      if (value == undefined || value == null || value === '') return true;
      return false;
    };

    const setValueInData = (key, value) => {
      if (!isNullOrEmpty(value)) {
        proxy.model[key] = value;
      }
    };

    const getBudgetSubItemName = item => {
      let index = proxy.cacheBudgetSubItemComboConfig.data.findIndex(
        x => x.budget_item_code == item.budget_sub_item_code,
      );
      if (index != -1) return proxy.cacheBudgetSubItemComboConfig.data[index].budget_item_name;
      return '';
    };

    const getBudgetItemName = item => {
      let index = proxy.cacheBudgetItemComboConfig.data.findIndex(x => x.budget_item_code == item.budget_item_code);
      if (index != -1) return proxy.cacheBudgetItemComboConfig.data[index].budget_item_name;
      return '';
    };
    /**
     * Lấy mã nguồn NSSS
     */
    const getBudgetSourcePropertyCode = item => {
      if (!item.budget_source_id) return '';
      let indexBS = proxy.cacheBudgetSourceComboConfig.data.findIndex(x => x.budget_source_id == item.budget_source_id);
      if (indexBS == -1) return '';
      let itemBS = proxy.cacheBudgetSourceComboConfig.data[indexBS];
      let indexBSP = proxy.cacheBudgetSourcePropertyComboConfig.data.findIndex(
        x => x.budget_source_property_id == itemBS.budget_source_property_id,
      );
      if (indexBSP == -1) return '';
      return proxy.cacheBudgetSourcePropertyComboConfig.data[indexBSP].budget_source_property_code;
    };

    /**
     * Lấy nội dung hiện thị
     */
    const getContentDisplay = item => {
      switch (proxy.model.payment_content) {
        case 'description':
          return item.description;
        case 'journal_memo':
          return proxy.model.journal_memo;
        case 'budget_sub_item_name':
          return getBudgetSubItemName(item); // Tên tiểu mục
        case 'budget_item_name':
          let itemName = getBudgetItemName(item);
          let subItemName = getBudgetSubItemName(item);
          let center = '-';
          if (isNullOrEmpty(itemName) || isNullOrEmpty(subItemName)) center = '';
          return `${itemName} ${center} ${subItemName}`; //Tên mục và Tên tiểu mục
        default:
          return '';
      }
    };

    /**
     * Lấy giá trị trong dbOption
     */
    const setDbOptionInReport = () => {
      // Gắn dbOption
      let dbOptionKeys = [
        'CompanyName',
        'CompanyChiefAccountantTitle',
        'CompanyDirectorTitle',
        'CompanyDirector',
        'CompanyChiefAccountant',
      ];
      dbOptionKeys.forEach(element => {
        setValueInData(element, dbOptions.value[element]);
      });
      if (dbOptions.value.PrintTitleAccordingCircularTemplate || proxy.model.CompanyChiefAccountantTitle == '') {
        proxy.model.CompanyChiefAccountantTitle = 'Kế toán trưởng';
      }
      if (dbOptions.value.PrintTitleAccordingCircularTemplate || proxy.model.CompanyDirectorTitle == '') {
        proxy.model.CompanyDirectorTitle = 'Thủ trưởng đơn vị';
      }
      if (!dbOptions.value.PrintPersonNameInReport || dbOptions.value.PrintPersonNameInReportBudget) {
        proxy.model.CompanyChiefAccountant = '';
      }
      if (!dbOptions.value.PrintPersonNameInReport || dbOptions.value.PrintPersonNameInReportBudget) {
        proxy.model.CompanyDirector = '';
      }
    };
    /**
     * Lấy giá trị hiện thi khi lựa chọn "Không lặp lại thông tin trùng nhau"
     */
    const getRowDataDisplay = (oldValue, newValue, isNoDuplicate) => {
      if (!isNoDuplicate) return {oldValue: oldValue, newValue: newValue};
      if (oldValue == newValue) return {oldValue: oldValue, newValue: ''};
      oldValue = newValue;
      return {oldValue: oldValue, newValue: newValue};
    };

    /**
     * Lấy giá cả master và detail báo cáo
     */
    const getMasterAndDetailData = () => {
      var dataVoucher = props.dataReport.dataVoucher;
      var dataParam = props.dataReport.dataParam;
      var dataParamKey = [
        'PaymentMethod',
        'contract_template',
        'contract_perform',
        'debit_account_1',
        'credit_account_1',
        'debit_account_2',
        'credit_account_2',
        'debit_account_3',
        'credit_account_3',
        'tax_payer_organization_code',
        'organization_code',
        'organization_name',
        'organization_address',
        'accounting_object_code',
        'bank_account',
        'use_add_info',
        'use_sec',
        'add_sec_info',
        'add_info',
        'payment_content',
      ];
      let masterKeys = [
        'bank_info_code',
        'bank_info_name',
        'accounting_object_bank_account',
        'accounting_object_bank_name',
        'project_name',
        'project_code',
        'accounting_object_name',
        'accounting_object_id',
        'journal_memo',
      ];

      dataParamKey.forEach(element => {
        setValueInData(element, dataParam[element]);
      });

      masterKeys.forEach(element => {
        setValueInData(element, dataVoucher[element]);
      });

      if (dataParam.has_font_size) {
        proxy.model.font_size = dataParam.font_size + 3.5;
        proxy.fontSizeDV = 'px';
      } else {
        proxy.fontSizeDV = 'pt';
      }
      // Lấy thong tin gắn séc
      if (
        proxy.accountingObjectCombo.length > 0 &&
        proxy.model.accounting_object_id &&
        proxy.model.accounting_object_id != '' &&
        proxy.model.use_sec
      ) {
        let item = proxy.accountingObjectCombo.filter(
          x =>
            x.accounting_object_id == proxy.model.accounting_object_id &&
            (x.is_personal == true || x.is_employee == true),
        );
        if (item) {
          proxy.model.paramIdentification_number = item[0].identification_number;
          if (item[0].issue_date) {
            proxy.model.issueDate = `${item[0].issue_date.getDate()}/${
              item[0].issue_date.getMonth() + 1
            }/${item[0].issue_date.getFullYear()}`;
          }
          proxy.model.issueBy = item[0].issue_by;
        }
      }

      //Tổng tiền
      proxy.model.total_amonut = dataVoucher.total_amount;
      proxy.model.total_amonut_text = numberText(dataVoucher.total_amount);
      proxy.model.ref_no = dataVoucher.ref_no;
      setValueInData('posted_year', proxy.postedDate.getFullYear());
      if (dataVoucher.ref_date) {
        // Tháng 01,02, 3=>9
        let month =
          dataVoucher.ref_date.getMonth() > 1
            ? `${dataVoucher.ref_date.getMonth() + 1}`
            : `0${dataVoucher.ref_date.getMonth() + 1}`;
        let date =
          dataVoucher.ref_date.getDate() > 9
            ? `${dataVoucher.ref_date.getDate()}`
            : `0${dataVoucher.ref_date.getDate()}`;
        proxy.model.ref_date = `Ngày ${date} tháng ${month} năm ${dataVoucher.ref_date.getFullYear()}`;
      }

      // Dữ liệu detail
      if (dataVoucher.Detail?.length > 0) {
        let dataDetail = [];
        let old_budget_sub_item_code = '';
        let old_budget_chapter_code = '';
        let old_budget_sub_kind_item_code = '';
        let old_budget_source_property_code = '';
        let is_not_repeat_duplicate = dataParam.not_repeat_duplicate;
        var details = dataVoucher.Detail.filter(x => x.state != 3 && x.state != 4);
        details
          .sort(function (a, b) {
            return a.sort_order - b.sort_order;
          })
          .sort(function (a, b) {
            return a.budget_sub_kind_item_code - b.budget_sub_kind_item_code;
          })
          .sort(function (a, b) {
            return a.budget_chapter_code - b.budget_chapter_code;
          })
          .sort(function (a, b) {
            return a.budget_sub_item_code - b.budget_sub_item_code;
          })
          .forEach(item => {
            //lấy budget_source_property_code từ budget_source_id
            let new_budget_source_property_code = getBudgetSourcePropertyCode(item);
            let valueOne = getRowDataDisplay(
              old_budget_sub_item_code,
              item.budget_sub_item_code,
              is_not_repeat_duplicate,
            );
            old_budget_sub_item_code = valueOne.oldValue;
            let valueTwo = getRowDataDisplay(
              old_budget_chapter_code,
              item.budget_chapter_code,
              is_not_repeat_duplicate,
            );
            old_budget_chapter_code = valueTwo.oldValue;
            let valueThree = getRowDataDisplay(
              old_budget_sub_kind_item_code,
              item.budget_sub_kind_item_code,
              is_not_repeat_duplicate,
            );
            old_budget_sub_kind_item_code = valueThree.oldValue;
            let valueFour = getRowDataDisplay(
              old_budget_source_property_code,
              new_budget_source_property_code,
              is_not_repeat_duplicate,
            );
            old_budget_source_property_code = valueFour.oldValue;
            dataDetail.push({
              description: getContentDisplay(item),
              budget_sub_item_code: valueOne.newValue, // Mã NDKT
              budget_chapter_code: valueTwo.newValue, // Mã chương
              budget_sub_kind_item_code: valueThree.newValue, // Mã ngày KT
              budget_source_property_code: valueFour.newValue, // Mã nguồn NSNN
              amount: item.amount,
            });
          });
        proxy.model.Detail = ref(dataDetail);
        setValueInData('cash_withdraw_type_id', details[0]?.cash_withdraw_type_id);
      }
    };

    /**
     * Lấy dữ liệu chứng từ để hiện thị
     */
    const getVoucherReportData = () => {
      setDbOptionInReport();
      getMasterAndDetailData();
      // emit ra component cha để
      proxy.$nextTick(() => {
        let tr = proxy.$el.querySelectorAll('tr');
        let totalHeight = 0;
        let isFooter = false;
        let footerClasses = ['footer-report', 'footer-report-org'];
        let maxHeight = 1000;
        let isBreak = false;
        tr.forEach(element => {
          totalHeight += element.getBoundingClientRect().height;
          if (element.classList.contains('footer-report')) {
            if (totalHeight + 150 > maxHeight) isBreak = true;
            isFooter = true;
          }
          // Footer ĐV
          if (!isBreak && element.classList.contains('footer-report-org')) {
            totalHeight += 262;
          }

          if (totalHeight > maxHeight && (!isFooter || footerClasses.some(x => element.classList.contains(x)))) {
            isBreak = true;
          }
          if (isBreak) {
            element.classList.add('html2pdf__page-break');
            if (element.nextElementSibling.classList.contains('table-row')) {
              element.nextElementSibling.classList.add('border-top');
            }
            let trEmpty = document.createElement('tr');
            trEmpty.style.height = '35px';
            element.parentNode.insertBefore(trEmpty, element.nextElementSibling);
            //Reset
            totalHeight = 0;
            isBreak = false;
          }
        });
        proxy.$emit('generatePDF', true);
      });
    };

    /**
     * Xử lý đọc số
     */
    const numberText = input => {
      if (input == 0) {
        return '';
      } else {
        let readNumber = input || 0;
        let isNegative = readNumber < 0;
        let readText = read((isNegative ? -readNumber : readNumber).toString());
        let result;
        if (isNegative) {
          result = 'Âm ' + readText;
        } else {
          result = readText.charAt(0).toUpperCase() + readText.slice(1);
        }
        if (result != null) {
          result = result.trim();
        }
        if (result == '') {
          result += 'Không';
        }
        result += ` đồng`;
        if (dbOptions.value.SayMoney_Even) {
          result += ' chẵn';
        }
        return dbOptions.value.SayMoney_Prefix + result + dbOptions.value.SayMoney_Surfix;
      }
    };

    const read = num => {
      // Đọc từng phần
      const output = [];

      let groupLength = num.length % 3;

      num = num.split('');
      for (let i = 0; i < 3 - groupLength && groupLength != 0; i++) {
        num.unshift('0');
      }
      num = num.join('');

      for (let i = 0; i < num.length / 3; i++) {
        let [a, b, c] = num.substr(i * 3, 3);
        a = parseInt(a);
        b = parseInt(b);
        c = parseInt(c);

        // Sửa lại ở đây
        const isFirstGroup = i == 0;
        // Nếu là rỗng thì sang bộ 3 tiếp theo
        if (a == 0 && b == 0 && c == 0) {
          continue;
        }

        output.push(...readThree(a, b, c, !isFirstGroup)); // Dùng spread operator

        // Đọc phần đơn vị của nhóm
        output.push(`${genUnits(num.length / 3 - 1 - i)}`);
      }
      return output.join(' ');
    };

    /**
     * giá trị đơn vị
     */
    const genUnits = index => {
      switch (index) {
        case 0:
          return '';
        default:
          let modIndex = index % 3;
          let res = '';
          switch (modIndex) {
            case 0:
              res = 'tỷ';
              break;
            case 1:
              res = `${dbOptions.value.SayMoney_Nghin}`;
              break;
            case 2:
              res = 'triệu';
              break;
          }
          if (dbOptions.value.SayMoney_ShowThousandSymbol) {
            res += ',';
          }
          return res;
      }
    };

    /**
     * Giá trị phần số
     */
    const genDigits = number => {
      switch (number) {
        case 0:
          return 'không';
        case 1:
          return 'một';
        case 2:
          return 'hai';
        case 3:
          return 'ba';
        case 4:
          return 'bốn';
        case 5:
          return 'năm';
        case 6:
          return 'sáu';
        case 7:
          return dbOptions.value.SayMoney_7;
        case 8:
          return 'tám';
        case 9:
          return 'chín';
      }
    };

    // Định nghĩa function đọc hai số cuối
    function readTwo(b, c, hasHundred) {
      const output = [];

      switch (b) {
        case 0: {
          // Nếu có đọc hàng trăm (đọc rồi) và b = 0, c = 0
          // thì không đọc nữa
          if (hasHundred && c == 0) break;
          if (hasHundred) output.push(dbOptions.value.SayMoney_Linh); // ví dụ a05 đọc là "a lẻ năm"
          output.push(genDigits(c));
          break;
        }

        case 1: {
          // Trường hợp số hàng chục là 10
          output.push('mười');
          if (c == 5) output.push('lăm'); // Mười lăm
          else if (c != 0) output.push(genDigits(c));
          // Trường hợp c = 0 không xét vì đã đọc "mười" rồi
          break;
        }

        default: {
          output.push(genDigits(b), dbOptions.value.SayMoney_Muoi); // b mươi
          if (c == 1) output.push('mốt');
          // Chỗ này đọc "tư" hay "bốn" thì các bạn điều chỉnh nhe
          // Mình sẽ luôn đọc là "tư" nhé
          else if (c == 4) output.push(dbOptions.value.SayMoney_4);
          else if (c == 5) output.push('lăm');
          else if (c != 0) output.push(genDigits(c));
          // Không đọc c = 0 vì đã đọc "b mươi" rồi
          break;
        }
      }

      // Trả về mảng output, xem lại phần trước nhé
      return output;
    }

    // Định nghĩa function đọc 3 số
    function readThree(a, b, c, readZeroHundred) {
      const output = [];

      // Đọc phần trăm (a) trước
      if (a != 0 || readZeroHundred) output.push(genDigits(a), 'trăm'); // Đọc là "a trăm"

      // Nối thêm phần sau (b, c)
      // Ở đây dùng spread syntax để nối output
      output.push(...readTwo(b, c, a != 0 || readZeroHundred));

      return output;
    }

    return {
      proxy,
      model,
      dbOptions,
      getVoucherReportData,
      numberText,
      accountingObjectCombo,
      cacheBudgetItemComboConfig,
      cacheBudgetSubItemComboConfig,
      cacheBudgetSourceComboConfig,
      cacheBudgetSourcePropertyComboConfig,
      fontSizeDV,
    };
  },
};
</script>

<style lang="scss" scoped>
.c202a-offline {
  background-color: white;
  .s5cd6f754 {
    font: 8pt Arial;
    border: 0px;
    text-align: center;
    vertical-align: middle;
    line-height: 1.1em;
    white-space: nowrap;
    overflow: hidden;
  }
  .sDetailTextCenter {
    font: 10pt 'Times New Roman';
    border: 1px solid black;
    text-align: center;
    vertical-align: middle;
    line-height: 1.09em;
    word-wrap: break-word;
    overflow: hidden;
  }
  .sd400aa50 {
    font: 8pt Arial;
    border: 0px;
    text-align: center;
    vertical-align: middle;
    line-height: 1.1em;
    white-space: nowrap;
    overflow: hidden;
  }
  .sCT_FormNo {
    font: bold 12pt 'Times New Roman';
    border: 0px;
    text-align: center;
    vertical-align: middle;
    line-height: 1.09em;
    white-space: nowrap;
    overflow: hidden;
  }
  .sDetailText {
    font: 10pt 'Times New Roman';
    border: 0px;
    text-align: left;
    vertical-align: middle;
    line-height: 1.09em;
    word-wrap: break-word;
    overflow: hidden;
  }
  .sDetailText1 {
    font: 10pt 'Times New Roman';
    border: 0px;
    text-align: left;
    vertical-align: middle;
    line-height: 1.09em;
    white-space: nowrap;
    overflow: hidden;
  }
  .sf672e7c2 {
    font: 8pt Arial;
    border: 0px;
    text-align: center;
    vertical-align: middle;
    line-height: 1.1em;
    white-space: nowrap;
    overflow: hidden;
  }
  .sCT_Title {
    font: bold 14pt 'Times New Roman';
    border: 0px;
    text-align: center;
    vertical-align: bottom;
    line-height: 1.09em;
    white-space: nowrap;
    overflow: hidden;
  }
  .sDetailText2 {
    font: 10pt 'Times New Roman';
    border: 0px;
    text-align: center;
    vertical-align: middle;
    line-height: 1.09em;
    white-space: nowrap;
    overflow: hidden;
  }
  .s584be2f9 {
    font: 8pt Arial;
    border: 0px;
    text-align: center;
    vertical-align: middle;
    line-height: 1.1em;
    white-space: nowrap;
    overflow: hidden;
  }
  .s9f47607e {
    font: 8pt Arial;
    border: 0px;
    text-align: center;
    vertical-align: middle;
    line-height: 1.1em;
    white-space: nowrap;
    overflow: hidden;
  }
  .s6f01f6ff {
    font: 8pt Arial;
    border: 0px;
    text-align: center;
    vertical-align: middle;
    line-height: 1.1em;
    white-space: nowrap;
    overflow: hidden;
  }
  .border-left {
    border-left: 1px solid black;
  }
  .sCT_Table_DetailText_MLNS {
    font: 10pt 'Times New Roman';
    border: 1px solid black;
    text-align: center;
    vertical-align: middle;
    line-height: 1.09em;
    white-space: nowrap;
    overflow: hidden;
  }
  .sf7752501 {
    font: 8pt Arial;
    border: 0px;
    text-align: center;
    vertical-align: middle;
    line-height: 1.1em;
    white-space: nowrap;
    overflow: hidden;
  }
  .s9bbd135f {
    font: 8pt Arial;
    border: 0px;
    text-align: center;
    vertical-align: middle;
    line-height: 1.1em;
    white-space: nowrap;
    overflow: hidden;
  }
  .s9bda6bbe {
    font: 10pt 'Times New Roman';
    border: 0px;
    text-align: left;
    vertical-align: middle;
    line-height: 1.14em;
    word-wrap: break-word;
    overflow: hidden;
    white-space: pre-wrap;
  }
  .h-31px {
    height: 31px;
  }
  .h-19px {
    height: 19px;
  }
  .company-name-title {
    height: 15px;
    width: 117px;
    max-height: 15px;
    max-width: 117px;
  }
  .account-name-title {
    white-space: pre-wrap;
    height: 19px;
    max-width: 714px;
    width: 714px;
    max-height: 19px;
  }
  .s92554d74 {
    font: 10pt 'Times New Roman';
    border: 0px;
    text-align: left;
    vertical-align: middle;
    line-height: 1.09em;
    word-wrap: break-word;
    overflow: hidden;
  }
  .sDetailHeader {
    font: bold 10.7pt 'Times New Roman';
    border: 1px solid black;
    text-align: center;
    vertical-align: middle;
    line-height: 1.09em;
    white-space: nowrap;
    overflow: hidden;
  }
  .sDetailHeader1 {
    font: bold 10.7pt 'Times New Roman';
    border: 1px solid black;
    border-left: 0px !important;
    text-align: center;
    vertical-align: middle;
    line-height: 1.09em;
    word-wrap: break-word;
    overflow: hidden;
  }
  .sBC_Table_SubHeader {
    font: 10pt 'Times New Roman';
    border: 1px solid black;
    border-top: 0px !important;
    direction: rtl;
    text-align: center;
    vertical-align: middle;
    line-height: 1.09em;
    word-wrap: break-word;
    overflow: hidden;
  }
  .sBC_Table_SubHeader1 {
    font: 10pt 'Times New Roman';
    border: 1px solid black;
    border-top: 0px !important;
    border-left: 0px;
    direction: rtl;
    text-align: center;
    vertical-align: middle;
    line-height: 1.09em;
    word-wrap: break-word;
    overflow: hidden;
  }
  .sBC_Table_SubHeader2 {
    font: 10pt 'Times New Roman';
    border: 1px solid black;
    border-top: 0px !important;
    border-left: 0px;
    text-align: center;
    vertical-align: middle;
    line-height: 1.09em;
    word-wrap: break-word;
    overflow: hidden;
  }
  .s4d90dce5 {
    font: 10pt 'Times New Roman';
    border: 1px solid black;
    border-bottom: 0px;
    text-align: left;
    vertical-align: middle;
    line-height: 1.09em;
    word-wrap: break-word;
    overflow: hidden;
  }
  .s8af4d46b {
    font: 10pt 'Times New Roman';
    border: 1px solid black;
    border-left: 0px;
    border-bottom: 0px;
    text-align: center;
    vertical-align: middle;
    line-height: 1.09em;
    word-wrap: break-word;
    overflow: hidden;
  }
  .s0c488c38 {
    font: 9pt 'Arial Narrow';
    border: 0px;
    border-top-color: Black;
    border-top-style: solid;
    border-top-width: 1px;
    border-right-color: Black;
    border-right-style: solid;
    border-right-width: 1px;
    text-align: right;
    vertical-align: middle;
    line-height: 1.1em;
    word-wrap: break-word;
    overflow: hidden;
  }
  .se865e78b {
    font: 10pt 'Times New Roman';
    border: 0px;
    border-top-color: #80808075;
    border-top-style: dotted;
    border-top-width: 1px;
    border-left-color: Black;
    border-left-style: solid;
    border-left-width: 1px;
    border-right-color: Black;
    border-right-style: solid;
    border-right-width: 1px;
    text-align: left;
    vertical-align: middle;
    line-height: 1.09em;
    word-wrap: break-word;
    overflow: hidden;
  }
  .s1f59be16 {
    font: 10pt 'Times New Roman';
    border: 0px;
    border-top-color: #80808075;
    border-top-style: dotted;
    border-top-width: 1px;
    border-right-color: Black;
    border-right-style: solid;
    border-right-width: 1px;
    text-align: center;
    vertical-align: middle;
    line-height: 1.09em;
    word-wrap: break-word;
    overflow: hidden;
  }
  .sacf10bdf {
    font: 9pt 'Arial Narrow';
    border: 0px;
    border-top-color: #80808075;
    border-top-style: dotted;
    border-top-width: 1px;
    border-right-color: Black;
    border-right-style: solid;
    border-right-width: 1px;
    text-align: right;
    vertical-align: middle;
    line-height: 1.1em;
    word-wrap: break-word;
    overflow: hidden;
  }
  .s1f5e3174 {
    font: 10pt 'Times New Roman';
    border: 0px;
    border-top-color: #80808075;
    border-top-style: dotted;
    border-top-width: 1px;
    border-left-color: Black;
    border-left-style: solid;
    border-left-width: 1px;
    border-right-color: Black;
    border-right-style: solid;
    border-right-width: 1px;
    border-bottom-color: Black;
    border-bottom-style: solid;
    border-bottom-width: 1px;
    text-align: left;
    vertical-align: middle;
    line-height: 1.09em;
    word-wrap: break-word;
    overflow: hidden;
  }
  .s2cdd73b9 {
    font: 10pt 'Times New Roman';
    border: 0px;
    border-top-color: #80808075;
    border-top-style: dotted;
    border-top-width: 1px;
    border-right-color: Black;
    border-right-style: solid;
    border-right-width: 1px;
    border-bottom-color: Black;
    border-bottom-style: solid;
    border-bottom-width: 1px;
    text-align: center;
    vertical-align: middle;
    line-height: 1.09em;
    word-wrap: break-word;
    overflow: hidden;
  }
  .s9b79d212 {
    font: 9pt 'Arial Narrow';
    border: 0px;
    border-top-color: #80808075;
    border-top-style: dotted;
    border-top-width: 1px;
    border-right-color: Black;
    border-right-style: solid;
    border-right-width: 1px;
    border-bottom: 1px solid black;
    text-align: right;
    vertical-align: middle;
    line-height: 1.1em;
    word-wrap: break-word;
    overflow: hidden;
  }
  .s9e5d76c9 {
    font: bold 10pt 'Times New Roman';
    border: 0px;
    border: 1px solid black;
    text-align: right;
    vertical-align: middle;
    line-height: 1.09em;
    white-space: nowrap;
    overflow: hidden;
  }
  .border-top-none {
    border-top: 0px;
  }
  .s075e0772 {
    font: bold 9pt 'Arial Narrow';
    border: 1px solid black;
    border-left: 0px;
    text-align: right;
    vertical-align: middle;
    line-height: 1.1em;
    word-wrap: break-word;
    overflow: hidden;
  }
  .s07b556ce {
    font: 8pt Arial;
    border: 0px;
    text-align: center;
    vertical-align: middle;
    line-height: 1.1em;
    white-space: nowrap;
    overflow: hidden;
  }
  .scf32fa05 {
    font: 8pt Arial;
    border: 0px;
    text-align: center;
    vertical-align: middle;
    line-height: 1.1em;
    white-space: nowrap;
    overflow: hidden;
  }
  .sDetailHeader2 {
    font: bold 11pt 'Times New Roman';
    border: 0px;
    border-top-color: Black;
    border-top-style: solid;
    border-top-width: 1px;
    border-left-color: Black;
    border-left-style: solid;
    border-left-width: 1px;
    border-right-color: Black;
    border-right-style: solid;
    border-right-width: 1px;
    border-bottom-color: Black;
    border-bottom-style: solid;
    border-bottom-width: 1px;
    text-align: center;
    vertical-align: middle;
    line-height: 1.09em;
    word-wrap: break-word;
    overflow: hidden;
  }
  .sDetailText3 {
    font: 10pt 'Times New Roman';
    border: 0px;
    border-left-color: Black;
    border-left-style: solid;
    border-left-width: 1px;
    border-right-color: Black;
    border-right-style: solid;
    border-right-width: 1px;
    text-align: left;
    vertical-align: middle;
    line-height: 1.09em;
    white-space: nowrap;
    overflow: hidden;
  }
  .sDetailText4 {
    font: 10pt 'Times New Roman';
    border: 0px;
    border-left-color: Black;
    border-left-style: solid;
    border-left-width: 1px;
    border-right-color: Black;
    border-right-style: solid;
    border-right-width: 1px;
    text-align: left;
    vertical-align: middle;
    line-height: 1.09em;
    white-space: nowrap;
    overflow: hidden;
  }
  .sDetailText5 {
    font: 10pt 'Times New Roman';
    border: 0px;
    border-left-color: Black;
    border-left-style: solid;
    border-left-width: 1px;
    border-right-color: Black;
    border-right-style: solid;
    border-right-width: 1px;
    border-bottom-color: Black;
    border-bottom-style: solid;
    border-bottom-width: 1px;
    text-align: left;
    vertical-align: middle;
    line-height: 1.09em;
    white-space: nowrap;
    overflow: hidden;
  }
  .sBC_Sign_Date {
    font: italic 11pt 'Times New Roman';
    border: 0px;
    text-align: center;
    vertical-align: middle;
    line-height: 1.09em;
    white-space: nowrap;
    overflow: hidden;
  }
  .sCT_Sign_Title {
    font: bold 10pt 'Times New Roman';
    border: 0px;
    text-align: center;
    vertical-align: middle;
    line-height: 1.09em;
    white-space: nowrap;
    overflow: hidden;
  }
  .sCT_Sign_SubTitle {
    font: italic 10pt 'Times New Roman';
    border: 0px;
    text-align: center;
    vertical-align: middle;
    line-height: 1.09em;
    white-space: nowrap;
    overflow: hidden;
  }
  .sCT_Sign_SubTitle1 {
    font: italic 10pt 'Times New Roman';
    border: 0px;
    text-align: center;
    vertical-align: middle;
    line-height: 1.09em;
    word-wrap: break-word;
    overflow: hidden;
  }
  .sCT_Sign_People {
    font: bold 10pt 'Times New Roman';
    border: 0px;
    text-align: center;
    vertical-align: middle;
    line-height: 1.09em;
    white-space: nowrap;
    overflow: hidden;
  }
  .sBC_Sign_Org {
    font: bold 11pt 'Times New Roman';
    border: 0px;
    text-align: center;
    vertical-align: middle;
    line-height: 1.09em;
    white-space: nowrap;
    overflow: hidden;
  }
  .sSignerDate {
    font: italic 11pt 'Times New Roman';
    border: 0px;
    text-align: center;
    vertical-align: middle;
    line-height: 1.09em;
    white-space: nowrap;
    overflow: hidden;
  }
  .sBC_Sign_Title {
    font: bold 11pt 'Times New Roman';
    border: 0px;
    text-align: center;
    vertical-align: middle;
    line-height: 1.09em;
    white-space: nowrap;
    overflow: hidden;
  }
  .sBC_Sign_Title1 {
    font: bold 11pt 'Times New Roman';
    border: 0px;
    text-align: center;
    vertical-align: middle;
    line-height: 1.09em;
    word-wrap: break-word;
    overflow: hidden;
  }
  .pagemargins {
    padding: 10mm 10mm 5mm 10mm;
    border: 0;
  }
  .sddaff93d {
    font: 10pt 'Times New Roman';
    border: 0px;
    border-left-color: Black;
    border-left-style: solid;
    border-left-width: 1px;
    border-right-color: Black;
    border-right-style: solid;
    border-right-width: 1px;
    border-top-color: #80808075;
    border-top-style: dotted;
    border-top-width: 1px;
    text-align: left;
    vertical-align: middle;
    line-height: 1.09em;
    word-wrap: break-word;
    overflow: hidden;
  }
  .sae4197fc {
    font: 10pt 'Times New Roman';
    border: 0px;
    border-right-color: Black;
    border-right-style: solid;
    border-right-width: 1px;
    border-top-color: #80808075;
    border-top-style: dotted;
    border-top-width: 1px;
    text-align: center;
    vertical-align: middle;
    line-height: 1.09em;
    word-wrap: break-word;
    overflow: hidden;
  }
  .scb139826 {
    font: 9pt 'Arial Narrow';
    border: 0px;
    border-right: 1px solid black;
    border-top-color: #80808075;
    border-top-style: dotted;
    border-top-width: 1px;
    text-align: right;
    vertical-align: middle;
    line-height: 1.1em;
    word-wrap: break-word;
    overflow: hidden;
  }
  .sfae43ad5 {
    font: 8pt Arial;
    border: 0px;
    text-align: center;
    vertical-align: middle;
    line-height: 1.1em;
    white-space: nowrap;
    overflow: hidden;
  }
  .s8c44c6e9 {
    font: 10pt 'Times New Roman';
    border: 0px;

    border-left-color: Black;
    border-left-style: solid;
    border-left-width: 1px;
    border-right-color: Black;
    border-right-style: solid;
    border-right-width: 1px;
    border-top-color: #80808075;
    border-top-style: dotted;
    border-top-width: 1px;
    text-align: left;
    vertical-align: middle;
    line-height: 1.09em;
    word-wrap: break-word;
    overflow: hidden;
  }
  .s94387e26 {
    font: 10pt 'Times New Roman';
    border: 0px;
    border-right-color: Black;
    border-right-style: solid;
    border-right-width: 1px;
    border-top-color: #80808075;
    border-top-style: dotted;
    border-top-width: 1px;
    text-align: center;
    vertical-align: middle;
    line-height: 1.09em;
    word-wrap: break-word;
    overflow: hidden;
  }
  .s3cdcfc03 {
    font: 9pt 'Arial Narrow';
    border: 0px;
    border-right-color: Black;
    border-right-style: solid;
    border-right-width: 1px;
    border-top-color: #80808075;
    border-top-style: dotted;
    border-top-width: 1px;
    text-align: right;
    vertical-align: middle;
    line-height: 1.1em;
    word-wrap: break-word;
    overflow: hidden;
  }
  .border-top {
    border-top: 1px solid black;
  }
  .border-right {
    border-right: 1px solid black !important;
  }
  .border-left {
    border-left: 1px solid black !important;
  }
  .no-warp {
    white-space: nowrap;
  }
}
</style>
